/* Flipside COA: the holographic certificate of authenticity.
   Plain script, no modules. Needs coa.css. The QR library (qrcode-generator 2.0.4, MIT, Kazuhiko Arase) is a theme
   asset, assets/qrcode-generator.js, loaded on demand through Flipside.asset (the frame's asset map) unless the page
   already has window.qrcode. Shopify port: no third-party script host.

   const c = FlipsideCOA.mount(el, data, { size:'md'|'lg'|'sm', controls:true });
   The visitor is in control (SITE-SPEC 10.1): press and drag tilts it and letting go settles it back. On touch (the
   owner's call for bounded controls, 2026-09-26) a sideways swipe tilts it at once, around its upright axis, with no
   hold; an up or down swipe scrolls the page (the stage is touch-action: pan-y), and a long press opens no menu. A click
   or tap flips it; the arrow keys tilt it. Opt-ins for labs only: hover:true (it follows a hovering mouse), sway:true (it floats on its own
   for a few seconds after it arrives). The old idle option is retired and ignored.
   Serials read CODE-NNNN (LS-03-0017), as on the live Registry. A record's link and QR code are the caller's recordUrl;
   without one they are the live Registry (Flipside.config.urls.registry, made absolute): ?s=LS-03-0017, or
   ?run=02&n=21 for a run without a public code. (The prototype's relative registry.html 404s on the store.)
   c.update(data)  swap in a new record with the "issued" moment
   c.flip([toBack]) turn it over; returns true when the back is showing
   c.tilt(rx, ry, { instant, hold, glare })  pose it (demos and tests); c.release() hands it back
   c.destroy()
*/
(function (win, doc) {
  'use strict';
  if (win.FlipsideCOA) return;

  /* FS crest, from assets/fs-mark.svg (1024 box, drawn at translate(555,153)). The few coordinates that would read
     like the USA 250 stock count are written in exponent form: the same values, and no stock-like token ships. */
  var CREST = 'M0 0 C2 0.1 3.9 0.2 5.9 0.3 C16.5 1 26.7 3.6 37 6 C38.9 6.4 40.8 6.9 42.7 7.3 C53.2 9.7 63.5 12.2 73.4 16.5 C77 18 80.7 19.4 84.4 20.8 C102.7 27.5 120.3 35.9 137 46 C137.8 46.5 138.6 46.9 139.4 47.4 C148.9 53.2 158.3 58.9 167 66 C168.5 67.2 170 68.3 171.4 69.4 C175.4 72.5 179.4 75.7 183.3 78.8 C185 80.2 186.7 81.5 188.4 82.9 C195.9 88.8 202.7 95.4 209.5 102.2 C211.3 104.1 213.2 105.9 215.1 107.8 C220.9 113.6 226.3 119.3 231 126 C232.5 127.8 233.9 129.6 235.4 131.4 C239 135.7 242.3 140.1 245.4 144.7 C246.8 146.8 248.3 148.8 249.9 150.8 C254.3 156.6 258.1 162.8 262 169 C262.5 169.8 263 170.6 263.5 171.4 C271.4 184.3 278.7 197.5 284.5 211.5 C285.9 214.7 287.3 217.8 288.8 220.9 C290.5 224.7 291.9 228.5 293.2 232.4 C294 235.1 294.9 237.8 295.8 240.4 C297.9 246.4 299.7 252.4 301.3 258.4 C301.8 260.4 302.4 262.3 303 264.3 C304.1 268.4 305 272.6 305.9 276.8 C307 281.8 308.2 286.8 309.6 291.7 C312.6 302.2 313.2 313.1 313.8 324 C314 327 314 327 315 330 C315.1 331.7 315.1 333.5 315.1 335.2 C315.1 335.8 315.1 335.8 315.1 338.5 C315.1 339.6 315.1 340.8 315.1 342 C315.1 343.2 315.1 344.3 315.1 345.6 C315.1 348.1 315.1 350.6 315.1 353.1 C315.1 356.9 315.1 360.8 315.1 364.6 C315.1 367 315.1 369.5 315.1 371.9 C315.1 373.1 315.1 374.2 315.1 375.4 C315.1 376.5 315.1 377.5 315.1 378.6 C315.1 379.1 315.1 379.1 315.1 381.5 C315 383.8 314.6 385.8 314 388 C313.8 389.9 313.7 391.9 313.6 393.8 C312.8 404.6 311.4 415.1 308.8 425.7 C307.9 429.3 307.3 432.9 306.7 436.6 C303.9 452.1 298.5 467.2 293 482 C292.7 482.8 292.4 483.6 292.1 484.4 C287.8 495.8 282.9 506.5 277 517.1 C275.5 520 274.1 522.9 272.7 525.8 C269.7 531.8 266.4 537.6 262.9 543.4 C262.4 544.2 262 545 261.4 545.9 C258.3 551.2 254.8 556.1 251 561 C249.8 562.7 248.5 564.5 247.3 566.2 C240.6 575.4 233.8 584.4 226.1 592.7 C223.5 595.6 220.9 598.6 218.4 601.6 C217 603 217 603 215 603 C214.8 603.6 214.5 604.2 214.3 604.8 C212.8 607.3 211.2 609.1 209 611 C208.3 611 207.7 611 207 611 C207 611.7 207 612.3 207 613 C206.3 613 205.7 613 205 613 C205 613.7 205 614.3 205 615 C204.3 615 203.7 615 203 615 C203 615.7 203 616.3 203 617 C201.5 618.5 201.5 618.5 199.4 620.2 C196.7 622.5 194 624.9 191.5 627.6 C188.6 630.5 185.5 633 182.2 635.4 C178.8 637.9 175.6 640.5 172.4 643.2 C170 645 167.6 646.5 165 648 C163.4 649.1 161.8 650.2 160.3 651.3 C153.4 656.1 146.7 660.7 139.3 664.7 C136.9 666.1 134.5 667.7 132.1 669.3 C126.2 673.1 120 676 113.6 678.9 C110.4 680.4 107.3 681.8 104.3 683.6 C101.5 685.3 98.7 686.4 95.6 687.5 C88.6 690.1 88.6 690.1 85.3 691.6 C81.9 693.1 78.4 694.1 74.9 695.1 C71.6 696.1 68.4 697.3 65.1 698.5 C58.8 700.8 52.5 702.5 46 704 C44.3 704.4 42.5 704.8 40.8 705.3 C23 709.5 23 709.5 14.1 709.9 C12 710 12 710 9 711 C6.9 711.2 4.7 711.4 2.6 711.5 C-3.6 711.9 -3.6 711.9 -5.9 712.5 C-30.2 718.4 -73.4 717.9 -97 710 C-98.6 709.8 -100.3 709.7 -101.9 709.6 C-112.6 708.6 -122.4 706.5 -132.5 703.3 C-135.4 702.5 -138.2 701.7 -141.1 701 C-155.6 697.3 -169.2 691.7 -183 686 C-183.4 685.8 -183.4 685.8 -185.7 684.9 C-209.4 675 -231.5 661.3 -252 646 C-252.5 645.6 -253.1 645.2 -253.6 644.8 C-273.3 630.1 -292.1 613.7 -308 595 C-308.9 593.9 -309.8 592.9 -310.8 591.8 C-313.4 588.8 -316 585.7 -318.6 582.7 C-319.8 581.2 -321.1 579.8 -322.3 578.3 C-328.8 570.7 -334.2 562.4 -339.6 554.1 C-340.8 552.3 -342.1 550.4 -343.3 548.6 C-347.3 542.8 -350.6 537 -353.6 530.6 C-355.1 527.7 -356.5 526.1 -359 524 C-361.9 523.5 -361.9 523.5 -365.4 523.6 C-366.6 523.6 -367.9 523.6 -369.3 523.6 C-370.7 523.6 -372.1 523.7 -373.5 523.7 C-374.9 523.7 -376.3 523.7 -377.8 523.7 C-381.6 523.7 -385.4 523.8 -389.2 523.8 C-395.2 523.9 -401.3 524 -407.4 524 C-409.5 524.1 -411.6 524.1 -413.7 524.1 C-415 524.1 -416.3 524.2 -417.6 524.2 C-418.8 524.2 -419.9 524.2 -421.1 524.2 C-423.9 524 -425.6 523.5 -428 522 C-427.7 515.1 -426.2 508.8 -424.3 502.2 C-421.5 492.6 -419.2 482.8 -416.9 473 C-411.6 450.4 -411.6 450.4 -408 445 C-405.2 444.6 -402.7 444.4 -399.9 444.3 C-399.1 444.3 -398.4 444.2 -397.6 444.2 C-395.7 444.1 -393.9 444.1 -392 444 C-390.8 439 -391.5 435.9 -393 431 C-393.6 428 -394 425.1 -394.4 422.1 C-395.9 412.4 -395.9 412.4 -396.8 407.9 C-398.9 398 -399.6 388.3 -399.8 378.2 C-400 376 -400 376 -400.5 373.6 C-401 370.9 -401.1 368.6 -401.1 365.9 C-401.1 365 -401.1 364 -401.1 363 C-401.1 362.1 -401.1 361.1 -401.1 360.1 C-401.1 359.1 -401.1 358.1 -401.1 357.1 C-401.1 352.3 -400.9 347.8 -400 343 C-399.8 339.9 -399.7 336.7 -399.6 333.6 C-399 320.2 -396.9 307.2 -394.4 294 C-394 292.1 -393.7 290.2 -393.3 288.2 C-389.4 265.8 -382.6 244.4 -374.2 223.2 C-373.3 220.9 -372.5 218.6 -371.7 216.3 C-368.3 206.6 -363.9 197.9 -359 188.9 C-357.6 186.2 -356.3 183.4 -354.9 180.6 C-352.5 175.6 -349.4 171.5 -345.8 167.3 C-342.7 163.4 -341 161.1 -341 156 C-341.8 156 -342.6 156 -343.5 156 C-347.1 156 -350.8 156.1 -354.4 156.1 C-355.7 156.1 -357 156.1 -358.3 156.1 C-359.5 156.1 -360.7 156.1 -362 156.1 C-362.6 156.1 -362.6 156.1 -365.4 156.1 C-368 156 -368 156 -369 155 C-369.7 148.4 -368.4 143.4 -366.1 137.2 C-364 131.1 -362.3 125 -360.8 118.7 C-359.9 115.1 -358.9 111.6 -357.5 108.1 C-355.7 103.4 -354.8 98.7 -353.9 93.8 C-351.5 80.5 -351.5 80.5 -348 77 C-345.4 76.8 -343 76.8 -340.4 76.8 C-340 76.8 -340 76.8 -338 76.8 C-336.3 76.8 -334.6 76.8 -332.9 76.8 C-330.2 76.8 -327.4 76.8 -324.7 76.8 C-317 76.8 -309.3 76.7 -301.6 76.8 C-296.9 76.8 -292.2 76.8 -287.4 76.7 C-285.7 76.7 -283.9 76.7 -282.1 76.8 C-264.3 76.9 -264.3 76.9 -257 70 C-256 69.2 -255.1 68.5 -254.1 67.7 C-253.3 67 -252.5 66.3 -251.6 65.6 C-247.2 61.9 -242.8 58.8 -237.9 55.8 C-235.5 54.3 -233.2 52.8 -230.8 51.2 C-225.9 47.9 -220.7 44.9 -215.6 41.9 C-214.7 41.4 -213.8 40.9 -212.9 40.4 C-203.6 35.1 -194.1 30.5 -184.1 26.5 C-182.2 25.7 -180.2 24.9 -178.3 24.1 C-177.3 23.8 -176.4 23.4 -175.5 23 C-172.6 21.8 -169.6 20.6 -166.7 19.3 C-151.1 12.8 -134.5 8 -117.8 5.1 C-113.7 4.3 -109.6 3.4 -105.4 2.4 C-99.3 0.9 -93.4 0.5 -87.1 0.2 C-84 0 -84 0 -81 -1 C-55.1 -5 -25.7 -5.2 0 0 Z M-82 31 C-84 31.3 -86.1 31.6 -88.1 31.9 C-93.2 32.8 -98.3 34 -103.3 35.2 C-106.6 35.9 -109.8 36.4 -113.1 36.9 C-119.8 37.9 -126.2 39.5 -132.7 41.3 C-133.9 41.6 -135 41.9 -136.2 42.2 C-149.5 45.9 -162.3 50.4 -175 56 C-176 56.5 -177.1 56.9 -178.1 57.4 C-200.7 67.4 -200.7 67.4 -207 75 C-207 76.3 -207 77.6 -207 79 C-205.2 79 -203.5 79.1 -201.7 79.1 C-200.7 79.1 -199.7 79.1 -198.7 79.1 C-196 79 -196 79 -193 78 C-191.4 77.9 -189.9 77.9 -188.3 77.9 C-187.3 77.9 -186.4 77.9 -185.4 77.9 C-184.3 77.9 -183.2 77.9 -182.1 77.9 C-181 77.9 -179.9 77.9 -178.7 77.9 C-1.749e2 77.9 -171 77.9 -167.2 77.9 C-164.5 77.9 -161.8 77.9 -159 77.9 C-153.2 77.9 -147.3 77.9 -141.4 77.9 C-132.9 77.9 -124.4 77.9 -115.8 77.9 C-102 77.9 -88.2 77.9 -74.4 77.9 C-61 77.9 -47.6 77.9 -34.2 78 C-33.4 78 -32.5 78 -31.7 78 C-27.5 78 -23.4 78 -19.2 78 C15.2 78 49.6 78 84 78 C84 81.5 84.1 84.6 83 88 C82.8 88.7 82.6 89.4 82.4 90.1 C82.3 90.5 82.3 90.5 81.7 92.3 C81.5 93.1 81.2 93.8 81 94.6 C79.4 99.8 77.8 104.9 76 110 C73 118.8 70.3 127.5 67.8 136.4 C63.2 153.3 63.2 153.3 60.5 159.4 C58.9 163.3 57.9 167 56.9 171.1 C55.3 178.4 55.3 178.4 53.9 181.7 C52.5 185.3 52.8 188.2 53 192 C54 193 54 193 57.6 193.1 C59.3 193.1 60.9 193.1 62.5 193.1 C64.3 193.1 66.1 193 67.9 193 C68.9 193 69.8 193 70.8 193 C113.2 192.8 113.2 192.8 131.5 196.2 C135.5 196.9 139.6 197.5 143.6 198.1 C161.7 200.6 179.8 205.4 195.8 214.7 C201 217.7 205.1 218 211 217 C215.2 215.7 219.1 213.9 223 212 C223.3 211.8 223.3 211.8 225 211 C227.2 210 229.4 208.9 231.6 207.9 C232.3 207.5 232.9 207.2 233.7 206.9 C240.6 203.4 240.6 203.4 242 201 C242 195.6 239.3 191.8 236.4 187.4 C236 186.7 235.5 186 235.1 185.3 C233.7 183.2 232.4 181.1 231 179 C230.6 178.4 230.2 177.8 229.8 177.2 C226.4 171.9 222.9 166.9 219 162 C217.6 160.1 216.2 158.2 214.8 156.3 C213.2 154.2 211.6 152.1 210 150 C209.4 149.2 208.8 148.4 208.2 147.6 C197.7 133.9 185.1 121 172 109.7 C170.7 108.6 169.4 107.5 168.1 106.3 C162.4 101.2 156.2 96.6 150 92 C149.2 91.4 148.5 90.9 147.7 90.3 C136.3 82 123.8 74.9 111.3 68.3 C109 67 106.7 65.6 104.4 64.1 C92.5 56.9 79 51.9 66 47 C65.5 46.8 65.5 46.8 63.2 45.9 C53.9 42.6 44.2 40.7 34.5 38.6 C31.4 37.9 28.4 37.1 25.3 36.4 C19.1 34.9 12.7 33.9 6.4 33 C5.6 32.9 4.8 32.8 4 32.7 C3.3 32.6 2.6 32.5 1.9 32.3 C0 32 0 32 -3 31 C-5.3 30.8 -7.6 30.6 -9.9 30.5 C-16.6 30.1 -16.6 30.1 -18.9 29.5 C-21.2 29 -23.1 28.9 -25.4 28.9 C-26.3 28.9 -27.2 28.8 -28.1 28.8 C-29 28.8 -30 28.8 -30.9 28.8 C-31.9 28.8 -32.9 28.8 -33.9 28.8 C-36 28.8 -38 28.8 -40.1 28.8 C-43.3 28.8 -46.4 28.8 -49.5 28.8 C-60.5 28.7 -71.1 29.1 -82 31 Z M-163.7 158.9 C-165.1 161.2 -165.7 163.2 -166.3 165.9 C-166.5 166.8 -166.7 167.8 -166.9 168.7 C-167 169.2 -167 169.2 -167.5 171.7 C-168.8 178 -170.2 184 -172.3 190.1 C-173.2 192.5 -173.7 195.1 -1.742e2 197.6 C-175.6 204 -177.5 210.2 -179.5 216.4 C-181.9 224.2 -184 231.9 -185.4 239.9 C-186 243.1 -187 246 -188 249 C-188.3 252.3 -188.3 252.3 -188 255 C-184.7 257.2 -184.1 257.2 -180.3 256.9 C-179.4 256.8 -178.5 256.8 -177.5 256.7 C-176.5 256.6 -175.6 256.5 -1.746e2 256.4 C-173.6 256.3 -172.6 256.2 -171.5 256.1 C-159.9 254.8 -149.8 252.1 -141 244 C-138.7 241.1 -136.8 238.2 -135 235 C-133.1 233.1 -130.4 233.9 -128 233.9 C-127.1 233.9 -126.3 233.9 -125.4 233.9 C-125 233.9 -125 233.9 -122.8 233.9 C-121 233.9 -119.1 233.9 -117.3 233.9 C-114.5 233.9 -111.7 233.9 -108.9 233.9 C-107.1 233.9 -105.4 233.9 -103.6 233.9 C-102.7 233.9 -101.9 233.9 -101 233.9 C-95.1 233.9 -95.1 233.9 -94 235 C-93.5 238.9 -94.6 241.5 -96.2 245 C-97.1 247.2 -97.5 249.1 -97.9 251.4 C-99.1 257.9 -100.8 264.2 -102.4 270.6 C-102.7 271.8 -103 273 -103.3 274.2 C-105.8 283.8 -105.8 283.8 -107.6 288.4 C-109 292 -109.7 295.3 -110.4 299.1 C-111.6 305.8 -113.6 311.9 -115.8 318.4 C-117.3 322.8 -118.3 327.3 -119.3 331.8 C-124.5 354.6 -124.5 354.6 -130 360 C-132.9 360.3 -135.7 360.4 -138.7 360.5 C-139.5 360.5 -140.4 360.5 -141.3 360.5 C-143.1 360.6 -144.9 360.6 -146.7 360.6 C-149.5 360.7 -152.3 360.8 -155.1 360.8 C-156.8 360.9 -158.6 360.9 -160.3 361 C-160.8 361 -160.8 361 -162.9 361 C-168.8 361.1 -168.8 361.1 -171 360 C-171.6 356.8 -172 353.7 -172.1 350.4 C-172.3 344.3 -173.3 340.5 -177.1 335.7 C-182.9 330.5 -188.7 330.5 -196.1 330.6 C-197.1 330.5 -198.1 330.5 -199.1 330.5 C-206.3 330.5 -206.3 330.5 -209.5 332.7 C-212 336.6 -213.2 340.6 -214.2 345 C-214.4 345.9 -214.6 346.9 -214.8 347.8 C-215.2 349.8 -215.6 351.7 -216.1 353.6 C-217.2 358.9 -218.6 364 -220.3 369 C-221.2 371.5 -221.8 374.1 -222.4 376.6 C-223.5 381.2 -224.7 385.7 -225.9 390.3 C-227.6 396.4 -229.2 402.6 -230.7 408.8 C-231.4 411.6 -232.1 414.3 -233 417 C-233.8 425.3 -232.4 431.3 -227.9 438.3 C-222.8 443.9 -215.1 445.2 -207.8 445.9 C-201.6 446.2 -195.5 445.6 -189.3 445.2 C-188.3 445.2 -187.2 445.1 -186.2 445.1 C-185.3 445 -184.3 444.9 -183.4 444.9 C-181 445 -181 445 -178 447 C-177.4 451.8 -178.7 455.5 -180.3 459.9 C-182.6 466.4 -184.1 472.8 -185.3 479.6 C-185.9 482.5 -186.6 485.2 -187.5 487.9 C-188.9 492.2 -189.7 496.6 -190.5 501 C-191.6 507.2 -193 513.1 -195 519 C-195.3 520 -195.7 521 -196 522 C-216 522.2 -216 522.2 -317 523 C-318.1 529.5 -317.5 531 -314 536 C-313.4 536.8 -312.8 537.7 -312.2 538.5 C-307.7 544.9 -302.9 551 -298 557 C-297.3 557.9 -296.6 558.8 -295.8 559.7 C-290.7 566 -285.4 572 -280 578 C-279.2 578.9 -278.4 579.8 -277.5 580.8 C-272.2 586.7 -266.6 592.4 -260.8 597.9 C-260.5 598.2 -260.5 598.2 -258.8 599.8 C-254.4 603.8 -249.8 607.5 -245 611 C-243.9 611.8 -242.9 612.6 -241.8 613.5 C-239.6 615.1 -237.5 616.8 -235.3 618.4 C-233.2 620 -231.1 621.7 -229.1 623.3 C-221.6 629 -213.9 634 -205.9 638.9 C-204.2 639.9 -202.5 640.9 -200.9 641.9 C-193.5 646.4 -185.8 649.9 -177.8 653.2 C-175.3 654.3 -172.8 655.5 -170.3 656.6 C-154 664 -136.9 668.9 -119.5 673.1 C-116.4 673.9 -113.3 674.7 -110.2 675.6 C-101.5 678 -92.9 679.2 -83.8 679.8 C-81 680 -81 680 -79.2 680.5 C-76.2 681.2 -73.4 681.1 -70.4 681.1 C-69.7 681.1 -69 681.1 -68.4 681.1 C-66.2 681.1 -64 681.1 -61.9 681.1 C-60.4 681.1 -58.9 681.1 -57.3 681.1 C-54.2 681.1 -51 681.1 -47.9 681.1 C-43.8 681.1 -39.8 681.1 -35.7 681.1 C-32.6 681.1 -29.5 681.1 -26.4 681.1 C-24.9 681.1 -23.4 681.1 -21.9 681.1 C-19.8 681.1 -17.7 681.1 -15.6 681.1 C-14.4 681.1 -13.3 681.1 -12 681.1 C-9.5 681 -7.4 680.7 -5 680 C-3 679.9 -1 679.8 1 679.7 C10.5 679.1 19.7 677.1 29 675 C29.8 674.8 30.6 674.7 31.3 674.5 C43.9 671.7 56.1 668.4 67.9 663.3 C71.2 661.9 74.5 660.8 77.9 659.6 C85.3 657 92.1 653.6 99 650 C101.3 648.9 103.7 647.7 106 646.6 C123.9 637.6 141.2 627 156.1 613.6 C158 612 159.8 610.6 161.8 609.2 C166.3 605.9 170.3 602.2 1.744e2 598.4 C176.5 596.5 178.6 594.6 180.8 592.8 C189 585.7 197.4 578 203.5 569 C205.2 566.7 207.1 564.8 209 562.7 C214.8 556.3 219.4 549.4 224.1 542.2 C224.9 540.9 225.8 539.6 226.6 538.3 C233.7 527.6 240.7 516.9 246.7 505.5 C247.1 504.8 247.4 504.1 247.8 503.3 C250.6 498 252.9 492.6 254.9 487 C256 484.1 257.2 481.3 258.5 478.5 C265.2 464 270.1 448.7 274.2 433.3 C274.4 432.3 274.7 431.4 275 430.4 C277.3 421.3 279.1 412.4 279.6 403.1 C279.9 396.3 279.9 396.3 280.5 394.2 C281.2 391.3 281.1 388.5 281.2 385.4 C281.2 384.8 281.2 384.1 281.2 383.5 C281.2 381.3 281.2 379.2 281.2 377 C281.2 376.6 281.2 376.6 281.2 374.8 C281.2 370.8 281.2 366.8 281.2 362.9 C281.2 359.7 281.3 356.4 281.3 353.2 C281.5 319.4 281.5 319.4 278.4 304 C277.8 301.1 277.3 298.3 276.9 295.4 C275.8 289.5 274.5 283.7 272.8 277.9 C272 275.1 271.3 272.2 270.6 269.4 C269 262.9 267.3 256.4 265.4 249.9 C265.2 249.2 265 248.5 264.8 247.8 C263.6 243.6 262.2 239.8 260 236 C257.8 235.1 257.8 235.1 256 235 C253.6 239.4 252.4 243.3 251.5 248.2 C250.7 252.7 249.8 257.1 248.5 261.4 C247.3 265.8 246.4 270.1 245.6 274.6 C244.2 282.9 241.9 290.9 239.6 299 C238.8 301.7 238.1 304.4 237.4 307.2 C236.3 311.8 235.1 316.5 233.9 321.1 C233.6 322.4 233.3 323.7 233 325 C232 328 232 328 230 330 C227.4 330.2 224.9 330.3 222.3 330.2 C221.5 330.2 220.7 330.2 219.8 330.2 C217.2 330.2 214.5 330.2 211.9 330.2 C210 330.2 208.2 330.2 206.4 330.2 C201.5 330.2 196.7 330.2 191.9 330.1 C186.9 330.1 182 330.1 177.1 330.1 C167.4 330.1 157.7 330 148 330 C147 325.6 147.2 321.8 147.6 317.4 C148.4 306.4 147.4 297.6 140 289 C128.1 276.5 110.8 269.4 93.5 268.7 C91.9 268.7 90.3 268.6 88.7 268.6 C87.9 268.6 87 268.6 86.1 268.6 C84.3 268.6 82.5 268.6 80.7 268.6 C78 268.6 75.3 268.5 72.5 268.5 C55.3 268.3 38.5 271.9 25.4 284.1 C20 290.6 19.3 298.8 20 307 C21.5 314.9 26.8 320 33.2 324.6 C35.7 326.2 38.3 327.6 41 329 C41.6 329.3 42.2 329.6 42.8 330 C51.7 334.6 60.6 338.6 70 342 C71.7 342.7 73.5 343.4 75.2 344.1 C76 344.4 76.8 344.7 77.6 345 C78.4 345.4 79.2 345.7 80 346 C82.5 347 85 348 87.5 349 C89.1 349.6 90.7 350.3 92.3 350.9 C96.1 352.5 99.9 354 103.8 355.4 C104.1 355.5 104.1 355.5 105.9 356.2 C107.2 356.7 108.5 357.2 109.9 357.6 C113.7 359.1 117.5 360.7 121.3 362.4 C127.1 365.1 133 367.3 138.9 369.5 C169.4 380.8 201.8 394.1 217.1 424.8 C217.2 425.2 217.2 425.2 218.1 427 C224.1 439.3 226.4 451.1 226.3 464.8 C226.3 465.9 226.3 467 226.3 468.2 C226.2 476.6 225.3 484 223 492 C222.7 493.8 222.3 495.5 222 497.3 C220.2 506.4 217.1 514.6 213 523 C212.7 523.6 212.4 524.3 212.1 524.9 C208.2 533 204.2 540.7 199 548 C198.5 548.8 197.9 549.6 197.3 550.5 C192.2 558 186.5 564.7 180 571 C179.8 571.3 179.8 571.3 178.5 572.6 C167.6 583.8 154.7 592.5 140.8 599.6 C139.7 600.1 138.6 600.7 137.5 601.3 C122.1 609.1 106.9 613.9 90.3 618.3 C88 619 88 619 86 620 C84.2 620.3 82.3 620.5 80.5 620.7 C80 620.8 80 620.8 77.2 621.1 C76 621.2 74.9 621.4 73.7 621.5 C71.4 621.8 69.2 622 66.9 622.3 C66.4 622.3 66.4 622.3 63.8 622.6 C62 622.9 60.2 623.2 58.4 623.5 C56 624 53.7 624.2 51.3 624.3 C50.4 624.4 49.4 624.4 48.5 624.4 C47.5 624.5 46.6 624.5 45.6 624.6 C45.1 624.6 45.1 624.6 42.5 624.7 C28.3 625.2 14.1 625.2 -0.1 624.6 C-1 624.5 -1.8 624.5 -2.7 624.4 C-3.4 624.4 -4.2 624.4 -5 624.3 C-5.7 624.3 -6.4 624.2 -7.1 624.2 C-9.1 624 -11 623.5 -13 623 C-15.2 622.8 -17.3 622.6 -19.5 622.5 C-25.6 622.1 -25.6 622.1 -28 621.5 C-31.9 620.5 -36.1 620.5 -40.1 620.3 C-43 620 -43 620 -45 619 C-46.5 618.8 -48 618.7 -49.5 618.6 C-54.1 618.2 -58.2 617.2 -62.6 615.8 C-64.8 615.1 -66.9 614.6 -69.1 614.1 C-80.4 611.7 -90.8 608 -101 602.6 C-107.6 599.2 -113.1 597.6 -120.4 599.7 C-122.8 600.7 -125.2 601.7 -127.6 602.8 C-128.4 603.2 -129.2 603.5 -130.1 603.9 C-131.6 604.6 -133.2 605.3 -134.8 606 C-144.2 610.3 -152.3 612.2 -162.6 612.8 C-166.5 613 -170.2 613.5 -1.74e2 614 C-1.747e2 614 -175.3 614 -176 614 C-176.2 608.3 -175.6 603.7 -173.8 598.3 C-171.8 591.9 -170.1 585.6 -168.6 579.1 C-165.1 564.1 -161.1 549.2 -156.7 534.4 C-155.2 529 -154.2 523.6 -153.2 518.2 C-152.5 514.1 -151.5 510.2 -150.3 506.3 C-150.1 505.6 -149.8 504.9 -149.6 504.2 C-149.4 503.6 -149.2 502.9 -149 502.3 C-146.9 495.3 -145.6 488.1 -144.3 480.9 C-144.1 479.7 -143.9 478.4 -143.6 477.2 C-143.1 474.1 -142.5 471.1 -142 468 C-130.3 468 -118.6 467.9 -106.9 467.9 C-101.5 467.9 -96.1 467.9 -90.7 467.9 C-85.4 467.8 -80.2 467.8 -75 467.8 C-73 467.8 -71 467.8 -69 467.8 C-66.2 467.8 -63.4 467.8 -60.6 467.8 C-59.8 467.8 -58.9 467.8 -58.1 467.8 C-54.2 467.8 -52.3 467.8 -49 470 C-49.5 475.1 -50.4 479.3 -52.2 484 C-55.3 492 -56.1 500.5 -55 509 C-53.2 512.2 -53.2 512.2 -51 515 C-50.4 515.8 -49.8 516.5 -49.2 517.3 C-34.3 534.6 -13.5 538.7 8.3 540.5 C15.7 541.1 22.9 541 30.3 540.3 C31.2 540.2 32.1 540.2 33.1 540.1 C46.3 538.7 58 534.4 69 527 C69.7 526.6 70.4 526.1 71.1 525.7 C78.2 520.9 82.2 514 85 506 C86 499.5 84.7 494.4 81 489 C71.8 478 58.8 472.1 45.8 466.5 C42.2 465 38.6 463.4 35.1 461.5 C29.8 458.8 24.3 456.7 18.7 454.6 C13.6 452.6 8.6 450.5 3.6 448.2 C-3.4 445 -10.7 442.4 -18.1 440 C-23.1 438.3 -28 436.4 -32.9 434.3 C-36 433 -39.2 431.8 -42.3 430.6 C-43.4 430.1 -44.5 429.7 -45.6 429.3 C-47.9 428.4 -50.2 427.6 -52.5 426.7 C-73.1 418.8 -94.3 409.2 -104.4 388.5 C-109.9 374.8 -108.1 362.1 -104.6 348.2 C-104 346.1 -103.5 344 -103 341.9 C-101.2 334.4 -99.1 327.1 -96.8 319.8 C-94.6 312.8 -93 305.7 -91.5 298.5 C-90.5 294 -89.3 289.7 -87.8 285.3 C-87 283 -86.3 280.7 -85.7 278.4 C-84.2 273.5 -82.4 268.7 -80.4 264 C-79 260.6 -77.7 257.2 -76.5 253.8 C-69.3 233 -54.8 223.7 -35.7 214.4 C-32.1 212.5 -29.9 210.6 -27.9 207 C-24.7 196.6 -25.5 182 -30.4 172.4 C-35.7 164.4 -42.8 159.4 -52 157 C-55.6 156.7 -59.1 156.7 -62.7 156.7 C-63.8 156.7 -64.9 156.7 -66 156.7 C-69.5 156.7 -73 156.7 -76.5 156.7 C-79 156.7 -81.4 156.7 -83.9 156.6 C-89 156.6 -94.1 156.6 -99.3 156.6 C-105.9 156.6 -112.4 156.6 -119 156.6 C-124.1 156.6 -129.1 156.5 -134.2 156.5 C-136.6 156.5 -139.1 156.5 -141.5 156.5 C-144.9 156.5 -148.3 156.5 -151.7 156.5 C-152.7 156.5 -153.7 156.5 -154.7 156.5 C-155.6 156.5 -156.5 156.5 -157.5 156.5 C-158.3 156.5 -159.1 156.5 -159.9 156.5 C-162 157 -162 157 -163.7 158.9 Z M-316.7 176.9 C-317.1 177.8 -317.6 178.6 -318.1 179.5 C-318.6 180.4 -319.1 181.3 -319.6 182.3 C-321.1 185.1 -322.5 188 -323.9 190.8 C-325.1 193.2 -326.4 195.3 -327.8 197.6 C-331 202.8 -333.3 208.3 -335.6 214 C-338.1 220.4 -340.7 226.6 -343.9 232.7 C-349.3 243.5 -352.1 255 -354.8 266.7 C-356.1 272.5 -357.7 278.2 -359.3 283.9 C-363.3 297.7 -365.2 311.5 -365.7 325.8 C-365.7 326.7 -365.7 327.6 -365.7 328.5 C-365.8 329.3 -365.8 330 -365.8 330.8 C-366 333 -366 333 -366.5 334.9 C-367 337.1 -367.1 339.2 -367.2 341.5 C-367.2 342.4 -367.2 343.3 -367.2 344.2 C-367.2 345.1 -367.2 346.1 -367.2 347 C-367.2 348 -367.2 349 -367.2 350 C-367.2 352.1 -367.2 354.2 -367.2 356.3 C-367.2 359.5 -367.3 362.6 -367.3 365.8 C-367.4 388.1 -367.4 388.1 -364 395 C-363 395.3 -362 395.7 -361 396 C-356.3 386.6 -354.1 376.6 -352.1 366.3 C-350.8 360 -349.3 353.7 -347.7 347.4 C-347.4 346.2 -347.1 345 -346.7 343.7 C-344.9 336.4 -343 329.3 -340.8 322.1 C-338.8 315.6 -337.3 309 -335.8 302.4 C-334.7 297.5 -333.3 292.8 -331.7 288.1 C-330.7 285.2 -330.2 282.4 -329.7 279.4 C-328.2 271.4 -325.9 263.7 -323.6 255.9 C-321.5 248.9 -319.9 242.1 -318.6 235 C-318 231.8 -317 229.1 -315.7 226.2 C-314.5 222.5 -313.9 218.5 -313.1 214.6 C-312.4 210.9 -311.5 207.3 -310.4 203.6 C-307.8 195.5 -307.2 186.5 -308 178 C-308.7 177 -309.3 176 -310 175 C-313.3 1.744e2 -314.4 1.744e2 -316.7 176.9 Z';
  var QR_NAME = 'qrcode-generator.js';   /* a theme asset, resolved through Flipside.asset */
  /* the live Registry page, absolute (a QR code must carry the whole address) */
  function registry() {
    var F = win.Flipside, u = F && F.config && F.config.urls && F.config.urls.registry;
    if (!u) { try { u = JSON.parse(doc.getElementById('flipside-config').textContent).urls.registry; } catch (e) { u = null; } }
    u = u || '/pages/ownership-registry';
    try { return new URL(u, win.location.href).href; } catch (e) { return u; }
  }
  var MAX = 14;                 /* max tilt, degrees */
  var IDLE_MS = 7000;           /* with sway:true, the float plays this long after the card arrives, then it rests */
  var SLOP = 8;                 /* touch: a finger that has come this far, more sideways than up or down, tilts the card */
  /* The light variables (--coa-*) each layer reads in coa.css. They are set on those layers only, never on the face, so
     when the light moves the readers restyle and the rest of the card does not (every reader is a leaf). Keep this
     table in step with coa.css: a layer that reads a variable and is missing here would sit at the resting light.
     (Registering them with @property, inherits:false, was measured too: in Chrome it made each style pass slower.) */
  var READERS = [
    ['.coa-no__emb', 'ex ey'], ['.coa-no__gold', 'fx fy'], ['.coa-win__ovd', 'fx fy sp'], ['.coa-win__state', 'fx fy'],
    ['.coa-holo-spec', 'fx fy gx gy'], ['.coa-holo-glare', 'ga gx gy sp'], ['.coa-holo-gold', 'fx sp'], ['.coa-spark', 'fx fy'],
    ['.coa-stripe__mot', 'fx fy'], ['.coa-stripe__flood', 'fx fy gy sp'], ['.coa-seal__rings', 'fx fy'],
    ['.coa-seal__flood', 'fx fy gx gy sp'], ['.coa-seal__cspec', 'fx fy'],
    ['.coa-rel--e', 'lE'], ['.coa-rel--w', 'lW'], ['.coa-rel--n', 'lN'], ['.coa-rel--s', 'lS'],
    ['.coa-sheen', 'ga gx gy'], ['.coa-glare', 'ga gx gy'], ['.coa-dim', 'dim'],
    ['.coa-crest__gold', 'fx fy'], ['.coa-ring .coa-holo-base', 'fx'], ['.coa-ring__spec', 'fx fy'], ['.coa-gloss', 'fx ga gx gy']
  ];
  var D2R = Math.PI / 180;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MICRO = 'FLIPSIDE HAT CO · THE BOOK KNOWS EVERY NUMBER · EMBROIDERED IN ST. LOUIS · ';   /* no run size (D7) */
  var RELIEF = '<div class="coa-rel coa-rel--e coa-t-re"></div><div class="coa-rel coa-rel--w coa-t-rw"></div><div class="coa-rel coa-rel--n coa-t-rn"></div><div class="coa-rel coa-rel--s coa-t-rs"></div>';
  var ICON_FLIP ='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 12a7.5 7.5 0 0 1 12.8-5.3M19.5 12a7.5 7.5 0 0 1-12.8 5.3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M17.8 2.8v4.4h-4.4M6.2 21.2v-4.4h4.4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function mq(q) { return win.matchMedia ? win.matchMedia(q) : { matches: false, addEventListener: function () {}, removeEventListener: function () {} }; }
  var RM = mq('(prefers-reduced-motion: reduce)');
  var COARSE = mq('(hover: none) and (pointer: coarse)');

  /* ---------------- helpers ---------------- */
  function pad3(n) { n = Math.max(0, parseInt(n, 10) || 0); return ('00' + n).slice(-3); }
  function pad4(n) { n = Math.max(0, parseInt(n, 10) || 0); return ('000' + n).slice(-4); }
  function absURL(u) { try { return new URL(u, doc.baseURI).href; } catch (e) { return u; } }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(e0, e1, x) { var t = clamp((x - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtDate(v) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(String(v || ''));   /* parsed by hand: no timezone drift */
    return m ? MONTHS[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] : String(v || '');
  }
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(seed) {
    return function () {
      seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function canvas(w, h) { var c = doc.createElement('canvas'); c.width = w; c.height = h; return c; }
  function ctx2(c) { return c.getContext('2d', { willReadFrequently: true }); }   /* CPU-backed: cheap to encode */
  var CRESTP = null;
  function crestPath() { return CRESTP || (CRESTP = new Path2D(CREST)); }
  function drawCrest(x, cx, cy, size) {        /* crest centred at cx,cy, `size` = 1024-box width */
    var s = size / 1024;
    x.save(); x.translate(cx - 512 * s, cy - 512 * s); x.scale(s, s); x.translate(555, 153); x.fill(crestPath()); x.restore();
  }

  function norm(src) {
    var d = {};
    for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) d[k] = src[k];
    d.number = parseInt(d.number, 10) || 0;
    d.size = parseInt(d.size, 10) || 50;
    d.drop = d.drop == null ? '' : ('0' + String(d.drop).replace(/\D/g, '')).slice(-2);
    d.code = d.code ? String(d.code).toUpperCase() : null;
    d.run = d.run || '';
    d.state = d.state || '';
    d.sample = d.sample !== false;
    d.serial = d.code ? d.code + '-' + pad4(d.number) : 'No. ' + pad4(d.number);
    d.spoken = d.code ? d.serial : d.run + ', number ' + d.number;
    d.seed = d.code ? d.code + ' ' + pad3(d.number) : 'No. ' + pad3(d.number);   /* the security fibres keep their pattern */
    var u = d.recordUrl;
    if (u && !d.code && /[?&](serial|s)=/i.test(u)) u = null;   /* a run without a public code never carries a serial */
    d.url = u || (d.code ? registry() + '?s=' + d.code + '-' + pad4(d.number) : registry() + '?run=' + d.drop + '&n=' + d.number);
    return d;
  }

  /* ---------------- shared textures (generated once) ---------------- */
  var TEX = null;
  function wrapDraw(size, px, py, fn) { for (var dx = -1; dx <= 1; dx++) for (var dy = -1; dy <= 1; dy++) fn(px + dx * size, py + dy * size); }

  /* Textures are drawn once per page, encoded off the main thread (toBlob) and referenced by short
     blob: URLs from one injected stylesheet. Rules land as each image is ready. */
  var TEXCSS = {}, TEXTAG = null;
  function texRule(key, rule) {
    TEXCSS[key] = rule;
    if (!TEXTAG) { TEXTAG = doc.createElement('style'); TEXTAG.setAttribute('data-coa', 'textures'); (doc.head || doc.documentElement).appendChild(TEXTAG); }
    var s = ''; for (var k in TEXCSS) s += TEXCSS[k];
    TEXTAG.textContent = s;
  }
  function ship(c, key, rule) {
    var done = function (url) { TEX[key] = url; texRule(key, rule(url)); };
    try {
      if (c.toBlob && win.URL && URL.createObjectURL) c.toBlob(function (b) { done(b ? URL.createObjectURL(b) : c.toDataURL()); }, 'image/png');
      else done(c.toDataURL());
    } catch (e) { try { done(c.toDataURL()); } catch (e2) { /* leave the layer plain */ } }
  }
  function bg(cls) { return function (u) { return '.' + cls + '{background-image:url("' + u + '")}'; }; }
  function mk(cls, extra) { return function (u) { return '.' + cls + '{-webkit-mask-image:url("' + u + '");mask-image:url("' + u + '")' + (extra || '') + '}'; }; }
  var later_ = win.requestIdleCallback ? function (f) { win.requestIdleCallback(f, { timeout: 400 }); } : function (f) { setTimeout(f, 60); };

  /* Texture work is a queue of small steps. The shapes run in the next task (they are quick); the rest runs in
     idle time, a step or a few at a time, so no single task gets long. */
  var TEXQ = [], TEXBUSY = false;
  function texPump(deadline) {
    var t0 = Date.now(), job;
    do { job = TEXQ.shift(); if (job) job(); }
    while (TEXQ.length && (deadline && deadline.timeRemaining ? deadline.timeRemaining() > 12 : Date.now() - t0 < 8));
    if (TEXQ.length) later_(texPump); else TEXBUSY = false;
  }
  function idle_(f, ms) { if (win.requestIdleCallback) win.requestIdleCallback(f, { timeout: ms }); else setTimeout(f, Math.min(ms, 700)); }
  function texQueue(jobs) { TEXQ = TEXQ.concat(jobs); if (!TEXBUSY) { TEXBUSY = true; later_(texPump); } }

  /* Every texture draws from one seeded sequence. Each step enters it exactly where that texture always began
     (sparkle at 0, blobs at 1500, grain at 1590, grunge at 66390), so running the steps in another order changes no pixel. */
  var SEED = 20260115;
  function rngAt(n) { var R = rng(SEED); while (n-- > 0) R(); return R; }
  /* until its image lands, a masked layer stays invisible: never an unmasked block of foil */
  var MASK_WAIT = '{-webkit-mask-image:linear-gradient(transparent,transparent);mask-image:linear-gradient(transparent,transparent)}';

  function texSparkle() {
    /* sparkle: white specks and a few cross glints on black (black is neutral under color-dodge). Two steps. */
    var R = rngAt(0), c = canvas(256, 256), x = ctx2(c);
    x.fillStyle = '#000'; x.fillRect(0, 0, 256, 256);
    function specks(count) {
      for (var i = 0; i < count; i++) {
        var sx = R() * 256, sy = R() * 256, sr = Math.pow(R(), 3) * 1.7 + 0.35, sa = 0.3 + R() * 0.7, hue = R();
        var col = hue < 0.7 ? '255,255,255' : hue < 0.85 ? '255,236,190' : '255,247,226';
        wrapDraw(256, sx, sy, function (px, py) {
          if (px < -12 || py < -12 || px > 268 || py > 268) return;
          if (sr < 0.8) { x.fillStyle = 'rgba(' + col + ',' + sa * 0.8 + ')'; x.beginPath(); x.arc(px, py, sr * 1.3, 0, 7); x.fill(); return; }
          var g = x.createRadialGradient(px, py, 0, px, py, sr * 2.4);
          g.addColorStop(0, 'rgba(' + col + ',' + sa + ')'); g.addColorStop(0.35, 'rgba(' + col + ',' + sa * 0.5 + ')'); g.addColorStop(1, 'rgba(' + col + ',0)');
          x.fillStyle = g; x.fillRect(px - sr * 3, py - sr * 3, sr * 6, sr * 6);
          if (sr > 1.3) {
            x.strokeStyle = 'rgba(' + col + ',' + sa * 0.65 + ')'; x.lineWidth = 0.55;
            x.beginPath(); x.moveTo(px - sr * 4.5, py); x.lineTo(px + sr * 4.5, py); x.moveTo(px, py - sr * 4.5); x.lineTo(px, py + sr * 4.5); x.stroke();
          }
        });
      }
    }
    return [function () { specks(150); }, function () { specks(150); ship(c, 'spark', bg('coa-t-spark')); }];
  }
  function texBlobs() {
    /* blobs: soft windows the sparkle shows through, so specks twinkle as they slide */
    var R = rngAt(1500), c = canvas(256, 256), x = ctx2(c), i;
    for (i = 0; i < 30; i++) {
      var bx = R() * 256, by = R() * 256, br = 9 + R() * 24;
      wrapDraw(256, bx, by, function (px, py) {
        if (px < -br || py < -br || px > 256 + br || py > 256 + br) return;
        var g = x.createRadialGradient(px, py, 0, px, py, br);
        g.addColorStop(0, 'rgba(255,255,255,.95)'); g.addColorStop(0.55, 'rgba(255,255,255,.45)'); g.addColorStop(1, 'rgba(255,255,255,0)');
        x.fillStyle = g; x.fillRect(px - br, py - br, br * 2, br * 2);
      });
    }
    ship(c, 'blobs', mk('coa-m-blobs'));
  }
  function texNoise() {
    /* paper grain: mostly white, a little tooth (multiplied onto the stock) */
    var R = rngAt(1590), c = canvas(180, 180), x = ctx2(c), i;
    var im = x.createImageData(180, 180), o = im.data;
    for (i = 0; i < 180 * 180; i++) {
      var v = 255 - Math.pow(R(), 2.6) * 46 - R() * 8;
      o[i * 4] = v; o[i * 4 + 1] = v - 2; o[i * 4 + 2] = v - 6; o[i * 4 + 3] = 255;
    }
    x.putImageData(im, 0, 0);
    ship(c, 'noise', bg('coa-t-noise'));
  }
  function texGrunge() {
    /* rubber stamp: ink coverage with pits and a couple of dry streaks */
    var R = rngAt(66390), c = canvas(240, 110), x = ctx2(c), i;
    x.fillStyle = '#000'; x.fillRect(0, 0, 240, 110);
    x.globalCompositeOperation = 'destination-out';
    for (i = 0; i < 1500; i++) { x.globalAlpha = 0.2 + R() * 0.8; x.beginPath(); x.arc(R() * 240, R() * 110, R() * R() * 1.9 + 0.2, 0, 7); x.fill(); }
    x.strokeStyle = '#000';
    for (i = 0; i < 6; i++) {
      x.globalAlpha = 0.25 + R() * 0.3; x.lineWidth = 0.6 + R() * 1.8; x.beginPath();
      var y0 = R() * 110; x.moveTo(-5, y0); x.bezierCurveTo(70, y0 + R() * 14 - 7, 160, y0 + R() * 14 - 7, 245, y0 + R() * 10 - 5); x.stroke();
    }
    x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    ship(c, 'grunge', mk('coa-m-grunge', ';-webkit-mask-size:100% 100%;mask-size:100% 100%'));
  }
  function texShapes() {
    var c, x, i;
    /* crest silhouette */
    c = canvas(512, 512); x = ctx2(c); x.fillStyle = '#fff'; drawCrest(x, 256, 256, 512);
    ship(c, 'crest', mk('coa-m-crest', ';-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:50% 50%;mask-position:50% 50%'));

    /* stripe motif: a crest and a four-point star per tile */
    c = canvas(144, 400); x = ctx2(c); x.fillStyle = '#fff';
    drawCrest(x, 72, 110, 150);
    x.beginPath();
    var st = [72, 300], s1 = 22, s2 = 5;
    for (i = 0; i < 8; i++) { var a = i * Math.PI / 4 - Math.PI / 2, rr = i % 2 ? s2 : s1; i ? x.lineTo(st[0] + Math.cos(a) * rr, st[1] + Math.sin(a) * rr) : x.moveTo(st[0] + Math.cos(a) * rr, st[1] + Math.sin(a) * rr); }
    x.closePath(); x.fill();
    ship(c, 'motif', mk('coa-m-motif'));

    /* hidden print over the photo: a lattice of small crests */
    c = canvas(160, 160); x = ctx2(c); x.fillStyle = '#fff';
    drawCrest(x, 40, 40, 86); drawCrest(x, 120, 120, 86);
    ship(c, 'ovd', mk('coa-m-ovd'));
  }

  function textures() {
    if (TEX) return TEX;
    TEX = {};
    ['crest', 'motif', 'ovd', 'blobs'].forEach(function (k) { texRule(k, '.coa-m-' + k + MASK_WAIT); });
    setTimeout(texShapes, 0);
    /* then, in idle time: the stamp and the grain (seen at rest), the sparkle (seen in motion), and the relief
       maps for the crests: four lights (E, W, N, S) mixed per frame */
    texQueue([texGrunge, texNoise, texBlobs].concat(texSparkle(), reliefJobs(320, function (x2, S) { x2.fillStyle = '#fff'; drawCrest(x2, S / 2, S / 2, S); }, 3, 4.8)));
    return TEX;
  }

  /* box blur, separable, running sums */
  function blur(A, w, h, r) {
    var B = new Float32Array(w * h), C = new Float32Array(w * h), x, y, acc, n = r * 2 + 1;
    for (y = 0; y < h; y++) {
      acc = 0; var row = y * w;
      for (x = -r; x <= r; x++) acc += A[row + clamp(x, 0, w - 1)];
      for (x = 0; x < w; x++) { B[row + x] = acc / n; acc += A[row + clamp(x + r + 1, 0, w - 1)] - A[row + clamp(x - r, 0, w - 1)]; }
    }
    for (x = 0; x < w; x++) {
      acc = 0;
      for (y = -r; y <= r; y++) acc += B[clamp(y, 0, h - 1) * w + x];
      for (y = 0; y < h; y++) { C[y * w + x] = acc / n; acc += B[clamp(y + r + 1, 0, h - 1) * w + x] - B[clamp(y - r, 0, h - 1) * w + x]; }
    }
    return C;
  }

  /* Emboss relief lit from four directions. Each map: white where the bevel faces that
     light, dark where it turns away. Mixing their opacities moves the light around.
     Five steps: the height field, then one step per light. */
  function reliefJobs(S, draw, rad, k) {
    var x, A, H, N = S * S;
    var jobs = [function () {
      var c = canvas(S, S); x = ctx2(c);
      draw(x, S);
      var src = x.getImageData(0, 0, S, S).data, i;
      A = new Float32Array(N);
      for (i = 0; i < N; i++) A[i] = src[i * 4 + 3] / 255;
      H = blur(blur(A, S, S, rad), S, S, rad);
    }];
    var dirs = { e: [1, 0], w: [-1, 0], n: [0, -1], s: [0, 1] };
    Object.keys(dirs).forEach(function (key) {
      jobs.push(function () {
        var lx = dirs[key][0], ly = dirs[key][1], img = x.createImageData(S, S), o = img.data;
        for (var yy = 1; yy < S - 1; yy++) {
          for (var xx = 1; xx < S - 1; xx++) {
            var p = yy * S + xx;
            if (A[p] <= 0.001) continue;
            var s = -((H[p + 1] - H[p - 1]) * lx + (H[p + S] - H[p - S]) * ly) * k * A[p];
            var q = p * 4;
            if (s > 0) { o[q] = 255; o[q + 1] = 247; o[q + 2] = 222; o[q + 3] = Math.min(255, s * 255); }
            else { o[q] = 46; o[q + 1] = 26; o[q + 2] = 6; o[q + 3] = Math.min(255, -s * 230); }
          }
        }
        var cc = canvas(S, S); ctx2(cc).putImageData(img, 0, 0);
        ship(cc, 'relief-' + key, bg('coa-t-r' + key));
      });
    });
    return jobs;
  }

  /* ---------------- engraving (drawn once per record and size) ---------------- */
  function roundRect(x, l, t, w, h, r) {
    x.beginPath(); x.moveTo(l + r, t); x.lineTo(l + w - r, t); x.arcTo(l + w, t, l + w, t + r, r); x.lineTo(l + w, t + h - r);
    x.arcTo(l + w, t + h, l + w - r, t + h, r); x.lineTo(l + r, t + h); x.arcTo(l, t + h, l, t + h - r, r); x.lineTo(l, t + r); x.arcTo(l, t, l + r, t, r); x.closePath();
  }
  function rosette(x, cx, cy, r0, amp, lobes, curves, turn) {
    for (var k = 0; k < curves; k++) {
      var ph = k * Math.PI * 2 / curves;
      x.beginPath();
      for (var i = 0; i <= 720; i++) {
        var th = i / 720 * Math.PI * 2;
        var r = r0 + amp * Math.sin(lobes * th + ph) * (turn ? Math.cos(turn * th - ph * 0.5) : 1);
        var px = cx + Math.cos(th) * r, py = cy + Math.sin(th) * r;
        i ? x.lineTo(px, py) : x.moveTo(px, py);
      }
      x.stroke();
    }
  }
  /* guilloche rope along a straight run from (x0,y0) to (x1,y1) */
  function rope(x, x0, y0, x1, y1, band, period, strands) {
    var len = Math.hypot(x1 - x0, y1 - y0), ux = (x1 - x0) / len, uy = (y1 - y0) / len, nx = -uy, ny = ux;
    for (var k = 0; k < strands; k++) {
      x.beginPath();
      for (var s = 0; s <= len; s += 0.12) {
        var off = band / 2 * Math.sin(s / period * Math.PI * 2 + k * Math.PI * 2 / strands);
        var px = x0 + ux * s + nx * off, py = y0 + uy * s + ny * off;
        s ? x.lineTo(px, py) : x.moveTo(px, py);
      }
      x.stroke();
    }
  }

  function prep(cv, sz) {
    var W = sz ? sz[0] : cv.clientWidth, H = sz ? sz[1] : cv.clientHeight;
    if (!W || !H) return null;
    var dpr = Math.min(win.devicePixelRatio || 1, 2);
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    var x = cv.getContext('2d'), u = W / 100 * dpr;
    x.setTransform(u, 0, 0, u, 0, 0);
    x.lineCap = 'round'; x.lineJoin = 'round';
    return { x: x, px: 100 / W };   /* px: one CSS pixel in card units */
  }

  /* The front engraving as a list of steps, in the order it has always been drawn. draw() runs them a slice at a time
     into a canvas off the page and copies the result onto the card once it is complete. */
  function frontJobs(cv, d, sz) {
    var P = prep(cv, sz); if (!P) return null;
    var x = P.x, px = P.px, R = rng(hash(d.seed + '|' + d.run + '|' + d.holder)), i, t;
    /* 1. a fine guilloche lattice, iris-printed from oxblood through umber to ochre */
    var g = x.createLinearGradient(0, 0, 100, 140);
    g.addColorStop(0, 'rgba(140,43,34,.2)'); g.addColorStop(0.5, 'rgba(88,76,50,.15)'); g.addColorStop(1, 'rgba(168,124,46,.22)');
    x.strokeStyle = g; x.lineWidth = 0.42 * px;
    var sp = Math.max(1.05, 3.4 * px), per = 6.6, TAU = Math.PI * 2;
    function family(fam) {
      x.strokeStyle = g; x.lineWidth = 0.42 * px;
      for (var y0 = -2; y0 < 142; y0 += sp) {
        x.beginPath();
        for (t = -1; t <= 101; t += 0.45) {
          var amp = sp * (0.62 + 0.38 * Math.sin(t * 0.052 + y0 * 0.047 + 0.8));
          var y = y0 + amp * Math.sin(t / per * TAU + y0 * 0.21 + fam * Math.PI);
          t > -1 ? x.lineTo(t, y) : x.moveTo(t, y);
        }
        x.stroke();
      }
    }
    return [
      function () { family(0); },
      function () { family(1);
        /* knock the field back where the typing sits */
        x.save(); x.globalCompositeOperation = 'destination-out';
        var kb = x.createLinearGradient(0, 84, 0, 120);
        kb.addColorStop(0, 'rgba(0,0,0,0)'); kb.addColorStop(0.2, 'rgba(0,0,0,.45)'); kb.addColorStop(0.85, 'rgba(0,0,0,.45)'); kb.addColorStop(1, 'rgba(0,0,0,0)');
        x.fillStyle = kb; x.fillRect(12, 84, 88, 36);
        var kh = x.createLinearGradient(0, 4, 0, 24);
        kh.addColorStop(0, 'rgba(0,0,0,0)'); kh.addColorStop(0.3, 'rgba(0,0,0,.35)'); kh.addColorStop(1, 'rgba(0,0,0,.1)');
        x.fillStyle = kh; x.fillRect(12, 4, 60, 20);
        x.restore();

      },
      function () {
      /* 2. rosette behind the gold number */
      var cx = 81.3, cy = 15.6;
      x.strokeStyle = 'rgba(150,108,42,.42)'; x.lineWidth = 0.42 * px;
      rosette(x, cx, cy, 8.9, 1.25, 18, 10, 0);
      x.strokeStyle = 'rgba(140,43,34,.3)';
      rosette(x, cx, cy, 11.1, 0.55, 42, 3, 0);
      x.strokeStyle = 'rgba(27,20,15,.35)'; x.lineWidth = 0.5 * px;
      x.beginPath(); x.arc(cx, cy, 12.1, 0, Math.PI * 2); x.stroke();
      x.beginPath(); x.arc(cx, cy, 6.7, 0, Math.PI * 2); x.stroke();
      x.save(); x.globalCompositeOperation = 'destination-out'; x.fillStyle = 'rgba(0,0,0,.55)';
      x.beginPath(); x.arc(cx, cy, 6.6, 0, Math.PI * 2); x.fill(); x.restore();

      },
      function () {
      /* 3. frame: rule, guilloche rope, rule */
      x.strokeStyle = 'rgba(27,20,15,.62)'; x.lineWidth = 0.75 * px;
      roundRect(x, 3, 3, 94, 134, 1.3); x.stroke();
      x.strokeStyle = 'rgba(104,72,26,.72)'; x.lineWidth = 0.45 * px;
      var b0 = 4.65, b1 = 95.35, c0 = 4.65, c1 = 135.35, per2 = Math.max(0.95, 2.6 * px);
      rope(x, b0 + 1.2, c0, b1 - 1.2, c0, 1.5, per2, 3);
      rope(x, b1, c0 + 1.2, b1, c1 - 1.2, 1.5, per2, 3);
      rope(x, b1 - 1.2, c1, b0 + 1.2, c1, 1.5, per2, 3);
      rope(x, b0, c1 - 1.2, b0, c0 + 1.2, 1.5, per2, 3);
      x.strokeStyle = 'rgba(27,20,15,.5)'; x.lineWidth = 0.5 * px;
      roundRect(x, 6.3, 6.3, 87.4, 127.4, 0.7); x.stroke();
      [[b0, c0], [b1, c0], [b1, c1], [b0, c1]].forEach(function (p) {
        x.fillStyle = '#efe3c8'; x.beginPath(); x.arc(p[0], p[1], 1.55, 0, 7); x.fill();
        x.strokeStyle = 'rgba(128,90,34,.8)'; x.lineWidth = 0.4 * px; rosette(x, p[0], p[1], 1.05, 0.38, 8, 3, 0);
        x.strokeStyle = 'rgba(27,20,15,.55)'; x.beginPath(); x.arc(p[0], p[1], 1.55, 0, 7); x.stroke();
      });

      },
      function () {
      /* 4. a watermark crest, pressed into the stock under the typing */
      x.save(); x.globalAlpha = 0.04; x.fillStyle = '#6b4f22'; drawCrest(x, 70, 104, 40); x.restore();

      /* 5. security fibres, unique to this serial */
      var cols = ['140,43,34', '66,88,138', '176,132,50', '40,110,96'];
      for (i = 0; i < 18; i++) {
        var fx0 = 7 + R() * 88, fy0 = 5 + R() * 130, ang = R() * Math.PI, len = 0.9 + R() * 1.7, bend = (R() - 0.5) * 1.2;
        x.strokeStyle = 'rgba(' + cols[(R() * cols.length) | 0] + ',' + (0.16 + R() * 0.16) + ')';
        x.lineWidth = (0.35 + R() * 0.3) * px;
        var ex = fx0 + Math.cos(ang) * len, ey = fy0 + Math.sin(ang) * len;
        x.beginPath(); x.moveTo(fx0, fy0);
        x.quadraticCurveTo((fx0 + ex) / 2 - Math.sin(ang) * bend, (fy0 + ey) / 2 + Math.cos(ang) * bend, ex, ey); x.stroke();
      }
      }
    ];
  }

  function drawBack(cv, sz) {
    var P = prep(cv, sz); if (!P) return;
    var x = P.x, px = P.px, i;
    x.lineWidth = 0.5 * px;
    /* tone-on-tone engraving in the lacquer */
    x.strokeStyle = 'rgba(211,171,87,.05)';
    for (i = 0; i < 44; i++) {
      var y0 = -3 + i * 146 / 43; x.beginPath();
      for (var t = -1; t <= 101; t += 0.6) { var y = y0 + 1.5 * Math.sin(t * 0.19 + y0 * 0.3); t > -1 ? x.lineTo(t, y) : x.moveTo(t, y); }
      x.stroke();
    }
    x.strokeStyle = 'rgba(211,171,87,.13)'; x.lineWidth = 0.45 * px;
    rosette(x, 50, 37, 25.2, 1.9, 30, 9, 0);
    x.strokeStyle = 'rgba(211,171,87,.08)';
    rosette(x, 50, 37, 29.3, 0.9, 64, 3, 0);
    x.strokeStyle = 'rgba(211,171,87,.2)'; x.lineWidth = 0.5 * px;
    x.beginPath(); x.arc(50, 37, 30.8, 0, 7); x.stroke();
    x.beginPath(); x.arc(50, 37, 22.6, 0, 7); x.stroke();
  }

  function drawTypeWindow(cv, sz) {
    var P = prep(cv, sz); if (!P) return;
    var x = P.x, px = P.px, i, W = 100, H = (sz ? sz[1] / sz[0] : cv.clientHeight / cv.clientWidth) * 100;
    x.strokeStyle = 'rgba(211,171,87,.16)'; x.lineWidth = 0.5 * px;
    for (i = 0; i < 72; i++) {
      var a = i / 72 * Math.PI * 2;
      x.beginPath(); x.moveTo(W / 2 + Math.cos(a) * 20, H / 2 + Math.sin(a) * 20); x.lineTo(W / 2 + Math.cos(a) * 90, H / 2 + Math.sin(a) * 90); x.stroke();
    }
    x.strokeStyle = 'rgba(211,171,87,.22)';
    rosette(x, W / 2, H / 2, 17, 1.6, 22, 8, 0);
    x.strokeStyle = 'rgba(211,171,87,.12)';
    rosette(x, W / 2, H / 2, 27, 1.2, 40, 4, 0);
  }

  /* ---------------- markup ---------------- */
  function typed(serial, seed) {
    var R = rng(seed), out = '';
    for (var i = 0; i < serial.length; i++) {
      var ch = serial.charAt(i);
      out += '<span style="--i:' + i + ';--j:' + ((R() - 0.5) * 1.2).toFixed(2) + ';--k:' + (R() * 0.9 - 0.1).toFixed(2) + '">' + (ch === ' ' ? '&nbsp;' : esc(ch)) + '</span>';
    }
    return out;
  }
  function frontHTML(d, small) {
    var win_ = d.img
      ? '<img src="' + esc(d.img) + '" alt="' + esc(d.imgAlt || (d.run + ' hat, Drop ' + d.drop)) + '" decoding="async" draggable="false"' + (d.imgPos ? ' style="object-position:' + esc(d.imgPos) + '"' : '') + '>' +
        '<div class="coa-win__ovd coa-m-ovd"></div>' +
        '<p class="coa-win__cap" aria-hidden="true">' + esc(d.run) + '<i>·</i>' + esc(d.state) + '</p>'
      : '<div class="coa-win__type" aria-hidden="true"><canvas></canvas><p class="coa-win__state">' + esc(d.run || d.state) + '</p>' +
        '<p class="coa-win__sub">Drop ' + esc(d.drop) + '<i>·</i>Fifty made</p></div>' +
        '<div class="coa-win__ovd coa-m-ovd"></div>';
    var strip = (d.code ? d.serial : (d.run || '').toUpperCase() + ' · ' + pad4(d.number));
    return '' +
      '<div class="coa-paper"></div>' +
      '<canvas class="coa-art" aria-hidden="true"></canvas>' +
      '<div class="coa-grain coa-t-noise" aria-hidden="true"></div>' +
      '<p class="coa-mark"><span class="coa-mark__w">Flipside</span><span class="coa-mark__co">Hat Co.</span></p>' +
      '<p class="coa-title">Certificate of Authenticity</p>' +
      '<div class="coa-no" aria-hidden="true"><span class="coa-no__lab">No.</span>' +
        '<span class="coa-no__n"><b class="coa-no__emb">' + d.number + '</b><b class="coa-no__gold">' + d.number + '</b></span>' +
        '<span class="coa-no__of">of ' + d.size + '</span></div>' +
      '<figure class="coa-win">' + win_ + '</figure>' +
      '<p class="coa-serial"><span class="coa-sr">Serial ' + esc(d.spoken) + '. </span><span class="coa-serial__t" aria-hidden="true">' + typed(d.serial, hash(d.serial)) + '</span></p>' +
      '<p class="coa-micro" aria-hidden="true"></p>' +
      '<dl class="coa-fields"></dl>' +
      '<p class="coa-foot"><b>Flipside Hat Co.</b><span>Embroidered in St. Louis</span></p>' +
      '<div class="coa-stripe" aria-hidden="true">' +
        '<div class="coa-holo-base"></div><div class="coa-holo-spec"></div>' +
        '<div class="coa-stripe__mot coa-m-motif"></div>' +
        '<div class="coa-holo-gold"></div>' +
        '<div class="coa-holo-glare"></div>' +
        (small ? '' : '<div class="coa-spark coa-t-spark coa-m-blobs"></div>') +
        '<span class="coa-stripe__txt">' + esc(strip) + '</span>' +
        '<div class="coa-stripe__edge"></div>' +
      '</div>' +
      '<div class="coa-seal" aria-hidden="true">' +
        '<div class="coa-holo-base"></div><div class="coa-seal__rings"></div>' +
        '<div class="coa-seal__crest coa-m-crest"></div><div class="coa-seal__cspec coa-m-crest"></div>' + RELIEF +
        '<div class="coa-holo-gold"></div>' +
        (small ? '' : '<div class="coa-spark coa-t-spark coa-m-blobs"></div>') +
        '<div class="coa-holo-glare"></div><div class="coa-seal__lip"></div>' +
      '</div>' +
      (d.sample ? '<p class="coa-stamp coa-m-grunge"><span>Sample</span></p>' : '') +
      '<div class="coa-sheen" aria-hidden="true"></div>' +
      '<div class="coa-glare" aria-hidden="true"></div>' +
      '<div class="coa-flash" aria-hidden="true"></div>' +
      '<div class="coa-dim" aria-hidden="true"></div>';
  }
  /* the micro line and the fields: filled into the front's empty containers (a task after the first mount) */
  function microText() { var m = ''; for (var i = 0; i < 4; i++) m += MICRO; return m; }
  function fieldsHTML(d) {
    return '<div class="coa-f coa-f--run" style="--r:0"><dt>Run</dt><dd>Drop ' + esc(d.drop) + ', ' + esc(d.run) + '</dd></div>' +
      '<div class="coa-f" style="--r:1"><dt>Number</dt><dd>' + d.number + ' of ' + d.size + '</dd></div>' +
      '<div class="coa-f" style="--r:2"><dt>Held by</dt><dd>' + esc(d.holder) + '</dd></div>' +
      '<div class="coa-f" style="--r:3"><dt>From</dt><dd>' + esc(d.from) + '</dd></div>' +
      '<div class="coa-f" style="--r:4"><dt>In the book since</dt><dd>' + esc(fmtDate(d.since)) + '</dd></div>';
  }
  function backHTML(d) {
    var micro = ''; for (var i = 0; i < 4; i++) micro += MICRO;
    return '' +
      '<div class="coa-lacq"></div>' +
      '<canvas class="coa-art" aria-hidden="true"></canvas>' +
      '<div class="coa-back-frame" aria-hidden="true"></div>' +
      '<p class="coa-b-label" aria-hidden="true">The flip side</p>' +
      '<div class="coa-ring" aria-hidden="true"><div class="coa-holo-base"></div><div class="coa-ring__spec"></div><div class="coa-holo-gold coa-holo-gold--pale"></div></div>' +
      '<div class="coa-crest" aria-hidden="true">' +
        '<div class="coa-crest__gold coa-m-crest"></div>' + RELIEF +
        '<div class="coa-spark coa-t-spark coa-m-crest"></div>' +
      '</div>' +
      '<p class="coa-line">You’ll never see your own number. <b>Everybody behind you will.</b></p>' +
      '<div class="coa-tag">' +
        '<div class="coa-qr"><span class="coa-qr__wait">QR</span></div>' +
        '<div class="coa-tag__txt">' +
          '<p class="coa-tag__scan">Scan it.</p>' +
          '<p class="coa-tag__book">It’s in the book.</p>' +
          '<p class="coa-tag__serial">' + esc(d.serial) + '</p>' +
          (d.sample ? '<p class="coa-tag__note">Sample certificate for this preview.</p>' : '') +
          '<a class="coa-tag__open" href="' + esc(d.url) + '" target="_blank" rel="noopener">Open the record</a>' +
        '</div>' +
        (d.sample ? '<p class="coa-tag__stamp coa-m-grunge"><span>Sample</span></p>' : '') +
      '</div>' +
      '<p class="coa-b-micro" aria-hidden="true">' + micro + '</p>' +
      '<div class="coa-gloss" aria-hidden="true"></div>' +
      '<div class="coa-dim" aria-hidden="true"></div>';
  }

  /* ---------------- QR (qrcode-generator, loaded on demand) ---------------- */
  var qrWait = null;
  function qrSrc() {
    var F = win.Flipside;
    if (F && typeof F.asset === 'function') { try { var u = F.asset(QR_NAME); if (u) return u; } catch (e) {} }
    return (F && F.assetBase ? F.assetBase : '') + QR_NAME;
  }
  function withQR(cb) {
    if (win.qrcode) { cb(); return; }
    if (!qrWait) {
      qrWait = [];
      var s = doc.createElement('script'); s.src = qrSrc(); s.async = true;
      s.onload = function () { var q = qrWait; qrWait = null; q.forEach(function (f) { f(); }); };
      s.onerror = function () { qrWait = null; };
      doc.head.appendChild(s);
    }
    if (qrWait) qrWait.push(cb);
  }
  function qrSVG(text, label) {
    var q = win.qrcode(0, 'M'); q.addData(text); q.make();
    var n = q.getModuleCount(), m = 1, size = n + m * 2, p = '';
    for (var r = 0; r < n; r++) {
      var c = 0;
      while (c < n) {
        if (q.isDark(r, c)) { var s = c; while (c < n && q.isDark(r, c)) c++; p += 'M' + (s + m) + ' ' + (r + m) + 'h' + (c - s) + 'v1h' + (s - c) + 'z'; }
        else c++;
      }
    }
    return '<svg viewBox="0 0 ' + size + ' ' + size + '" role="img" aria-label="' + esc(label) + '" shape-rendering="crispEdges"><path d="' + p + '" fill="#1b140f"/></svg>';
  }

  /* What is the card sitting on? Walk up to the first opaque background (or a gradient's first
     solid stop) and call it paper when it is light. Cream ledger: 'paper'. Soot page: 'soot'. */
  function surface(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = win.getComputedStyle(n), col = null;
      var bgc = /rgba?\(([^)]+)\)/.exec(cs.backgroundColor);
      if (bgc) { var p = bgc[1].split(',').map(parseFloat); if (p.length < 4 || p[3] >= 0.5) col = p; }
      if (!col && /gradient/.test(cs.backgroundImage)) {
        var stops = cs.backgroundImage.match(/rgba?\([^)]+\)/g) || [];
        for (var i = 0; i < stops.length && !col; i++) { var q = stops[i].replace(/rgba?\(|\)/g, '').split(',').map(parseFloat); if (q.length < 4 || q[3] >= 0.5) col = q; }
      }
      if (col) return (0.2126 * col[0] + 0.7152 * col[1] + 0.0722 * col[2]) / 255 > 0.55 ? 'paper' : 'soot';
    }
    return 'soot';
  }

  /* ---------------- the instance ---------------- */
  function COA(host, data, opt) {
    textures();
    var small = opt.size === 'sm' || opt.interactive === false;
    var root = doc.createElement('div');
    var theme = opt.theme === 'paper' || opt.theme === 'soot' ? opt.theme : surface(host);
    root.className = 'coa coa--' + (opt.size || 'md') + (opt.touch === 'none' ? ' coa--grab' : '') + (theme === 'paper' ? ' coa--paper' : '');
    root.setAttribute('data-side', 'front');
    root.innerHTML =
      '<div class="coa__stage">' +
        '<div class="coa__shadow" aria-hidden="true"></div>' +
        '<div class="coa__tilt"><div class="coa__card"' + (small ? '' : ' tabindex="0" role="group" aria-roledescription="certificate"') + '>' +
          '<div class="coa__edge coa__edge--l"></div><div class="coa__edge coa__edge--r"></div><div class="coa__edge coa__edge--t"></div><div class="coa__edge coa__edge--b"></div>' +
          '<section class="coa__face coa__face--front"' + (small ? '' : ' aria-label="Front of the certificate"') + '></section>' +
          (small ? '' : '<section class="coa__face coa__face--back" aria-label="Back of the certificate"></section>') +
        '</div></div>' +
      '</div>' +
      (small ? '' : opt.controls
        ? '<div class="coa__controls"><button type="button" class="coa__btn coa__btn--flip" aria-pressed="false">' + ICON_FLIP + '<span>Flip it</span></button>' +
          '<button type="button" class="coa__btn coa__btn--ghost coa__btn--gyro" aria-pressed="false" hidden>Tilt with your phone</button>' +
          '<p class="coa__note" aria-live="polite"></p></div>'
        : '') +
      (small ? '' : '<p class="coa-sr" aria-live="polite" data-coa-live></p>');
    host.appendChild(root);

    var q = function (s) { return root.querySelector(s); };
    var stage = q('.coa__stage'), shadow = q('.coa__shadow'), tiltEl = q('.coa__tilt'), card = q('.coa__card');
    var front = q('.coa__face--front'), back = q('.coa__face--back'), edges = root.querySelectorAll('.coa__edge');
    var btnFlip = q('.coa__btn--flip'), btnGyro = q('.coa__btn--gyro'), note = q('.coa__note'), live = q('[data-coa-live]');
    var d = null, W = 0, raf = 0, destroyed = false, timers = [];
    var backFor = null, backWait = false;   /* the record the back face was built for; it is built on the first flip, or in idle time */
    var S = {
      rx: 0, ry: 0, vx: 0, vy: 0, tx: 0, ty: 0,       /* tilt (deg) and target */
      fa: 0, vf: 0, tf: 0,                           /* flip angle */
      z: 0, vz: 0,                                   /* press depth (px) */
      ga: 0.22, sp: 0, dt: 1 / 60, back: false, frontVis: true,
      mode: 'idle', lastInput: -1e9, idleAmp: 0, idleUntil: 0, running: false, visible: !win.IntersectionObserver, atRest: false,
      rm: RM.matches, hold: null, key: null, gyro: false, gyroSeen: false, g0: null, gt: null, lastGyro: 0,
      ptr: null, entered: false, edgeK: -1
    };

    function later(fn, ms) {
      var id = setTimeout(function () { var i = timers.indexOf(id); if (i > -1) timers.splice(i, 1); fn(); }, ms);
      timers.push(id); return id;
    }
    function say(msg) { if (live) { live.textContent = ''; later(function () { live.textContent = msg; }, 30); } }
    function tell(msg) { if (note) { note.textContent = msg; } }

    /* ---- render a record ---- */
    var rendered = false;
    function fillFront(rec) {
      if (destroyed || rec !== d) return;
      var m = front.querySelector('.coa-micro'), f = front.querySelector('.coa-fields');
      if (m && !m.firstChild) m.textContent = microText();
      if (f && !f.firstChild) f.innerHTML = fieldsHTML(rec);
    }
    function render(src) {
      d = norm(src || {});
      front.innerHTML = frontHTML(d, small);
      fresh(front); front.__coaFloods = false;
      /* the first mount leaves the micro line and the fields to the next task; later records fill at once */
      if (rendered) fillFront(d); else { var rec = d; setTimeout(function () { fillFront(rec); }, 0); }
      rendered = true;
      if (back) { back.innerHTML = ''; backFor = null; fresh(back); }
      if (!small) card.setAttribute('aria-label', (d.sample ? 'Sample certificate' : 'Certificate') + ' of authenticity, ' + d.spoken + '. Press Enter to flip it.');
      if (W || !ro) draw();             /* on the first render the ResizeObserver brings the size, after layout, and draws */
      applySide(true);
      paint(true);
      if (back) soonBack();
    }
    function ensureBack() {
      if (!back || destroyed || !d || backFor === d) return;
      back.innerHTML = backHTML(d); backFor = d; fresh(back);
      /* the back's engraving is the size of the front's (both fill the face): no layout is forced to measure it */
      var b = back.querySelector('.coa-art');
      if (b && W) drawBack(b, artSize || [b.clientWidth, b.clientHeight]);
      fillQR();
    }
    function soonBack() {
      if (backWait) return; backWait = true;
      idle_(function () { backWait = false; ensureBack(); }, 2500);
    }
    /* Every size is read first (one layout at most); the drawing then runs a slice at a time in its own tasks, so no
       load-time task gets long. The front is drawn off the page and copied onto the card in one go, so the card never
       shows half an engraving; the first time, it fades in. A newer draw cancels an older one. */
    var artSize = null, drawTok = 0;
    function draw() {
      var a = front.querySelector('.coa-art'), tw = front.querySelector('.coa-win__type canvas'), b = backFor && back.querySelector('.coa-art');
      var sa = a && [a.clientWidth, a.clientHeight], st = tw && [tw.clientWidth, tw.clientHeight], sb = b && [b.clientWidth, b.clientHeight];
      if (sa && sa[0]) artSize = sa;
      var tok = ++drawTok, jobs = [];
      if (a) {
        var off = doc.createElement('canvas'), fj = frontJobs(off, d, sa);
        if (fj) {
          if (!a.__coaDrawn && !S.rm) a.style.opacity = '0';
          jobs = jobs.concat(fj, [function () {
            a.width = off.width; a.height = off.height;
            a.getContext('2d').drawImage(off, 0, 0);
            if (!a.__coaDrawn) { a.__coaDrawn = true; if (!S.rm) { a.style.transition = 'opacity .35s ease'; a.style.opacity = ''; } }
          }]);
        }
      }
      if (tw) jobs.push(function () { drawTypeWindow(tw, st); });
      if (b) jobs.push(function () { drawBack(b, sb); });
      var i = 0;
      var next = function () {
        if (tok !== drawTok || destroyed) return;
        var t0 = now();
        while (i < jobs.length) { jobs[i++](); if (now() - t0 > 6) break; }
        if (i < jobs.length) setTimeout(next, 0);
      };
      /* the first slice waits for the next frame, so it never joins the task that lays the card out */
      if (doc.hidden || !win.requestAnimationFrame) setTimeout(next, 0);
      else requestAnimationFrame(function () { setTimeout(next, 0); });
    }
    function fillQR() {
      var box = back.querySelector('.coa-qr'), rec = d;
      withQR(function () {
        /* the code itself is built in idle time, in a task of its own */
        idle_(function () {
          if (destroyed || rec !== d || !box.isConnected) return;
          try { box.innerHTML = qrSVG(absURL(rec.url), 'QR code. Opens the Registry record for ' + rec.spoken + '.'); } catch (e) { /* leave the placeholder */ }
        }, 1200);
      });
    }

    /* ---- sizing ---- */
    function measure() {
      var w = stage.clientWidth; if (!w || Math.abs(w - W) < 1) return;
      W = w;
      if (d) draw();                      /* first real size (e.g. mounted while hidden) or a resize; it reads before this writes */
      stage.style.perspective = Math.round(w * 3) + 'px';
    }
    var ro = win.ResizeObserver ? new ResizeObserver(function () { measure(); }) : null;
    if (ro) ro.observe(stage); else win.addEventListener('resize', measure);

    /* ---- side / a11y ---- */
    function applySide(quiet) {
      var showBack = S.back;
      root.setAttribute('data-side', showBack ? 'back' : 'front');
      if (back) {
        front.setAttribute('aria-hidden', showBack ? 'true' : 'false');
        back.setAttribute('aria-hidden', showBack ? 'false' : 'true');
        front.inert = showBack; back.inert = !showBack;
      }
      if (btnFlip) btnFlip.setAttribute('aria-pressed', showBack ? 'true' : 'false');
      if (!quiet) say(showBack ? 'Showing the back of the certificate.' : 'Showing the front of the certificate.');
    }
    function flip(toBack, dir) {
      if (!back) return false;
      var want = toBack == null ? !S.back : !!toBack;
      if (want === S.back) return S.back;
      if (want) ensureBack();
      S.back = want;
      if (!S.rm) { S.tf += 180 * (dir || 1); S.vz -= 60; kick(); }
      else paint(true);
      applySide(false);
      return S.back;
    }

    /* ---- the issued moment ---- */
    function issue() {
      root.classList.remove('coa--issue'); void root.offsetWidth; root.classList.add('coa--issue');
      clearTimeout(S.issueT); S.issueT = later(function () { root.classList.remove('coa--issue'); }, 2600);
      if (S.rm || small) return;
      S.vz -= 420; S.vx -= 30; S.lastInput = now(); kick();
      later(function () { if (!S.rm) { S.vz -= 320; S.vx += 70; S.vy += (S.ry >= 0 ? -1 : 1) * 26; S.lastInput = now() - 600; kick(); } }, 1210);
    }
    function update(src) {
      if (destroyed) return;
      var go = function () { render(src); issue(); S.idleUntil = now() + IDLE_MS + 1200; };
      if (S.back) { flip(false, -1); later(go, S.rm ? 0 : 330); } else go();
    }

    /* ---- physics ---- */
    function now() { return win.performance ? performance.now() : Date.now(); }
    function kick() {
      if (destroyed || small || S.running) return;
      S.running = true; S.last = now(); root.classList.add('coa--live'); raf = requestAnimationFrame(tick);
    }
    function idleAllowed() { return opt.sway === true && !S.rm && S.visible && !doc.hidden; }
    function targets(t, dt) {
      var mode = S.ptr && S.ptr.drag ? 'drag' : S.ptr && S.ptr.hover ? 'hover' : S.hold ? 'hold' : S.key ? 'key' : (S.gyro && t - S.lastGyro < 400) ? 'gyro' : 'idle';
      S.mode = mode;
      if (mode === 'drag' || mode === 'hover') { S.tx = S.ptr.tx; S.ty = S.ptr.ty; S.gaT = mode === 'drag' ? 0.75 : 0.6; }
      else if (mode === 'hold') { S.tx = S.hold.rx; S.ty = S.hold.ry; S.gaT = S.hold.glare; }
      else if (mode === 'key') { S.tx = S.key.rx; S.ty = S.key.ry; S.gaT = 0.55; if (t > S.key.until) S.key = null; }
      else if (mode === 'gyro') { S.tx = S.gt.rx; S.ty = S.gt.ry; S.gaT = 0.62; }
      if (mode === 'idle') {
        var on = idleAllowed() && t - S.lastInput > 1700 && t < S.idleUntil;
        S.idleAmp = on ? Math.min(1, S.idleAmp + dt * 0.45) : Math.max(0, S.idleAmp - dt * (t < S.idleUntil ? 2.5 : 0.7));
        var s = t / 1000, e = S.idleAmp * S.idleAmp * (3 - 2 * S.idleAmp);
        S.tx = e * (2.6 * Math.sin(s * 0.61) + 0.7 * Math.sin(s * 1.43 + 2.1));      /* about +/-3 deg */
        S.ty = e * (4.4 * Math.sin(s * 0.43 + 1.1) + 0.9 * Math.sin(s * 1.07));      /* about +/-5 deg */
        S.gaT = 0.2 + 0.14 * e;
      } else S.idleAmp = 0;
    }
    function integrate(dt) {
      var follow = S.mode !== 'idle';
      var k = follow ? 170 : 90, c = follow ? 20 : 10.5;
      if (S.mode === 'idle' && S.idleAmp > 0.02) { k = 60; c = 13; }
      var n = Math.max(1, Math.ceil(dt / 0.004)), h = dt / n;
      for (var i = 0; i < n; i++) {
        S.vx += (k * (S.tx - S.rx) - c * S.vx) * h; S.rx += S.vx * h;
        S.vy += (k * (S.ty - S.ry) - c * S.vy) * h; S.ry += S.vy * h;
        S.vf += (62 * (S.tf - S.fa) - 11.3 * S.vf) * h; S.fa += S.vf * h;
        S.vz += (130 * (0 - S.z) - 16 * S.vz) * h; S.z += S.vz * h;
      }
      S.ga += ((S.gaT == null ? 0.22 : S.gaT) - S.ga) * Math.min(1, dt * 6);
    }
    function settled() {
      return Math.abs(S.rx - S.tx) < 0.01 && Math.abs(S.ry - S.ty) < 0.01 && Math.abs(S.vx) < 0.02 && Math.abs(S.vy) < 0.02 &&
        Math.abs(S.fa - S.tf) < 0.01 && Math.abs(S.vf) < 0.02 && Math.abs(S.z) < 0.05 && Math.abs(S.vz) < 0.05;
    }
    function tick(t) {
      raf = 0;
      if (destroyed) return;
      var dt = Math.min(0.05, Math.max(0.001, (t - S.last) / 1000)); S.last = t;
      targets(t, dt);
      integrate(dt);
      S.dt = dt;
      paint(false);
      var busy = !settled() || !!S.key || S.gyro || S.idleAmp > 0 || (idleAllowed() && t < S.idleUntil) || Math.abs(S.sp - (S.spT || 0)) > 0.01;
      if (!busy) {
        /* at rest: land exactly on the target so the resting transforms are identity and text is pixel-crisp */
        S.rx = S.tx; S.ry = S.ty; S.vx = S.vy = 0; S.z = S.vz = 0; S.vf = 0;
        S.fa = S.tf = ((S.tf % 360) + 360) % 360;
        paint(true);
      }
      if (busy && S.visible && !doc.hidden) raf = requestAnimationFrame(tick);
      else { S.running = false; root.classList.remove('coa--live'); }
    }
    var EDGE_T = ['rotateY(-90deg) scaleX(', 'rotateY(90deg) scaleX(', 'rotateX(90deg) scaleY(', 'rotateX(-90deg) scaleY('];
    function setEdges(k) {
      if (S.edgeK === k) return; S.edgeK = k;
      for (var i = 0; i < edges.length; i++) { edges[i].style.visibility = k ? 'visible' : ''; edges[i].style.transform = k ? EDGE_T[i] + k.toFixed(3) + ')' : ''; }
    }
    function paint(force) {
      if (!W && !ro) measure();           /* with a ResizeObserver the size arrives after layout; never force one per frame */
      var w = W || 360;
      if (S.rm || small) {
        tiltEl.style.transform = ''; card.style.transform = '';
        front.style.transform = ''; if (back) back.style.transform = ''; setEdges(0);
        shadow.style.transform = ''; shadow.style.opacity = '';
        S.sp = 0;
        faceVars(front, -0.42, 0.28, 0, 0.22, null, 0);
        if (back) faceVars(back, -0.42, 0.28, 0, 0.22, null, 0);
        front.style.visibility = ''; if (back) back.style.visibility = '';
        return;
      }
      var sinf = Math.abs(Math.sin(S.fa * D2R));
      var lift = sinf * w * 0.1 + S.z;
      var rest = Math.abs(S.rx) < 0.004 && Math.abs(S.ry) < 0.004 && sinf < 1e-4 && Math.abs(S.z) < 0.02;
      if (rest) {
        /* flat and still: no 3D at all, so the browser draws the faces 1:1 */
        if (!S.atRest || force) {
          S.atRest = true;
          tiltEl.style.transform = 'none'; card.style.transform = 'none';
          front.style.transform = 'none'; if (back) back.style.transform = 'none';
          setEdges(0);
          shadow.style.transform = ''; shadow.style.opacity = '';
        }
      } else {
        S.atRest = false;
        var k = Math.min(1, sinf * 12), off = (k * w * 0.005).toFixed(2);   /* half the 1cqw thickness, only while turning */
        tiltEl.style.transform = 'rotateX(' + S.rx.toFixed(3) + 'deg) rotateY(' + S.ry.toFixed(3) + 'deg)';
        card.style.transform = 'translateZ(' + lift.toFixed(2) + 'px) rotateY(' + S.fa.toFixed(3) + 'deg) rotateX(' + (-sinf * 5).toFixed(3) + 'deg)';
        front.style.transform = k ? 'translateZ(' + off + 'px)' : 'none';
        if (back) back.style.transform = 'rotateY(180deg)' + (k ? ' translateZ(' + off + 'px)' : '');
        setEdges(k);
        var sh = sinf * 0.1 + Math.max(0, S.z) / w;
        shadow.style.transform = 'translate(' + (-S.ry * w * 0.0022).toFixed(2) + 'px,' + (S.rx * w * 0.0016 + sh * w * 0.2).toFixed(2) + 'px) scale(' + (1 + sh * 0.9 - Math.min(0, S.z) / w * 0.3).toFixed(4) + ')';
        shadow.style.opacity = (0.95 - sh * 3).toFixed(3);
      }
      var a = ((S.fa % 360) + 360) % 360, fv = a < 90 || a > 270;
      if (fv !== S.frontVis || force) {
        S.frontVis = fv;
        front.style.visibility = fv ? '' : 'hidden';
        if (back) back.style.visibility = fv ? 'hidden' : '';
      }
      var rel = fv ? (a > 180 ? a - 360 : a) : a - 180;
      var ryE = S.ry + rel;
      var mag = Math.sqrt(S.rx * S.rx + ryE * ryE);
      var vel = Math.sqrt(S.vx * S.vx + S.vy * S.vy) + Math.abs(S.vf) * 0.4;
      var spT = Math.max(smooth(5.5, 12.5, mag), smooth(6, 60, vel) * 0.7);   /* angle, or motion: a hologram flashes as it moves */
      S.spT = spT;
      S.sp = force ? spT : S.sp + (spT - S.sp) * Math.min(1, S.dt * 9);
      faceVars(fv ? front : back, clamp(ryE / MAX, -4, 4), clamp(S.rx / MAX, -1.6, 1.6), rel, S.ga, ryE, S.sp);
    }
    /* the readers of a face, by variable (rebuilt after the face's markup changes; see fresh()) */
    function readersOf(face) {
      if (face.__coaR) return face.__coaR;
      var by = {};
      READERS.forEach(function (r) {
        var els = face.querySelectorAll(r[0]);
        r[1].split(' ').forEach(function (k) {
          var list = by[k] || (by[k] = []);
          for (var i = 0; i < els.length; i++) if (list.indexOf(els[i]) < 0) list.push(els[i]);
        });
      });
      return (face.__coaR = by);
    }
    function fresh(face) { if (face) { face.__coaR = null; face.__coaV = {}; } }
    /* the two flood layers are transparent at rest; they join the front on its first tilt */
    function floods() {
      if (front.__coaFloods) return;
      front.__coaFloods = true;
      var sg = front.querySelector('.coa-stripe > .coa-holo-gold'), eg = front.querySelector('.coa-seal > .coa-holo-gold');
      if (sg) sg.insertAdjacentHTML('afterend', '<div class="coa-stripe__flood"></div>');
      if (eg) eg.insertAdjacentHTML('afterend', '<div class="coa-seal__flood"></div>');
      fresh(front);
    }
    function faceVars(face, fx, fy, rel, ga, ryE, sp) {
      if (!face) return;
      if (ryE == null) ryE = fx * MAX;
      var gx = 50 - 44 * fx, gy = 50 + 44 * fy;
      var ex = clamp(-0.3 - 2.2 * ryE * D2R, -1, 1), ey = clamp(-0.45 + 2.2 * fy * MAX * D2R, -1, 1);
      var v = {
        fx: fx.toFixed(4), fy: fy.toFixed(4), gx: gx.toFixed(2) + '%', gy: gy.toFixed(2) + '%', ga: ga.toFixed(3), sp: (sp || 0).toFixed(3),
        ex: ex.toFixed(3), ey: ey.toFixed(3), dim: ((1 - Math.cos((rel || 0) * D2R)) * 0.8).toFixed(3),
        lE: Math.max(0, ex).toFixed(3), lW: Math.max(0, -ex).toFixed(3), lS: Math.max(0, ey).toFixed(3), lN: Math.max(0, -ey).toFixed(3)
      };
      if (face === front && +v.sp > 0) floods();
      var by = readersOf(face), last = face.__coaV || (face.__coaV = {});
      for (var k in v) {
        if (last[k] === v[k]) continue;
        last[k] = v[k];
        var els = by[k]; if (!els) continue;
        for (var i = 0; i < els.length; i++) els[i].style.setProperty('--coa-' + k, v[k]);
      }
    }

    /* ---- input: pointer (mouse hover, touch drag, tap to flip) ---- */
    function local(e) {
      var r = stage.getBoundingClientRect();
      return { x: clamp((e.clientX - r.left) / r.width, 0, 1), y: clamp((e.clientY - r.top) / r.height, 0, 1), r: r };
    }
    function aimMouse(p) { S.ptr.tx = clamp(MAX * (p.y - 0.5) * 2.4, -MAX, MAX); S.ptr.ty = clamp(-MAX * (p.x - 0.5) * 2.4, -MAX, MAX); }   /* the side under the pointer lifts to it */
    function aimTouch(p) { S.ptr.tx = clamp(-MAX * (p.y - 0.5) * 2.9, -MAX, MAX); S.ptr.ty = clamp(MAX * (p.x - 0.5) * 2.9, -MAX, MAX); }   /* the finger presses its side down */
    /* a sideways swipe: the card turns around its upright axis as far as the finger has come since it landed (a third of
       the card's width is the whole tilt), the way the finger presses its side down; it does not tip up or down */
    function aimSwipe(p, e) { var r = stage.getBoundingClientRect(); S.ptr.tx = 0; S.ptr.ty = clamp(MAX * 2.9 * (e.clientX - p.x0) / r.width, -MAX, MAX); }
    function onDown(e) {
      if (e.button > 0) return;
      if (e.pointerType === 'touch') S.touchAt = now();
      if (S.rm && e.pointerType !== 'mouse') { S.ptr = { id: e.pointerId, x0: e.clientX, y0: e.clientY, t0: now(), type: e.pointerType, skip: !!e.target.closest('a,button') }; return; }
      S.lastInput = now();
      var p = S.ptr = { id: e.pointerId, x0: e.clientX, y0: e.clientY, t0: now(), type: e.pointerType, drag: false, hover: false, grab: false, moved: false,
        skip: !!e.target.closest('a,button') };
      if (e.pointerType === 'touch' && !S.rm && opt.touch === 'none') p.grab = true;   /* the page gave the card every touch: it tilts both ways */
    }
    function onMove(e) {
      if (S.rm) return;
      var p = S.ptr;
      if (e.pointerType === 'mouse' && opt.hover && !(e.buttons & 1) && !(p && p.drag)) {   /* opt-in: follow a hovering mouse */
        if (!p || p.type !== 'mouse') p = S.ptr = { id: e.pointerId, hover: true, type: 'mouse', tx: 0, ty: 0, x0: e.clientX, y0: e.clientY, t0: -1e9 };
        p.hover = true; aimMouse(local(e)); S.lastInput = now(); kick();
        return;
      }
      if (!p || p.id !== e.pointerId || p.hover) return;
      var dx = e.clientX - p.x0, dy = e.clientY - p.y0, far = dx * dx + dy * dy > SLOP * SLOP;
      if (far) p.moved = true;
      if (p.type === 'touch' && !p.grab) {
        /* a swipe: sideways tilts the card at once; up or down first is the page's (the browser scrolls it and cancels) */
        if (p.page) return;
        if (!p.drag) {
          if (!far) return;
          if (Math.abs(dx) <= Math.abs(dy)) { p.page = true; return; }
          p.drag = p.swipe = true; root.classList.add('coa--held');
          try { stage.setPointerCapture(e.pointerId); } catch (_) {}
        }
        aimSwipe(p, e); S.lastInput = now(); kick();
        return;
      }
      if (p.type === 'touch') { if (!p.grab) return; }
      else if (!(e.buttons & 1)) return;                  /* mouse and pen: only while pressed */
      if (!p.drag && (far || p.grab)) { p.drag = true; try { stage.setPointerCapture(e.pointerId); } catch (_) {} }
      if (p.drag) { aimTouch(local(e)); S.lastInput = now(); kick(); }
    }
    function endPtr(p) { if (p && p.timer) { clearTimeout(p.timer); p.timer = 0; } root.classList.remove('coa--held'); }
    function onUp(e) {
      var p = S.ptr; if (!p || p.id !== e.pointerId) { return; }
      var moved = Math.hypot(e.clientX - p.x0, e.clientY - p.y0);
      var tap = !p.skip && !p.drag && moved < 9 && now() - p.t0 < 550 && (e.pointerType !== 'mouse' || e.button === 0);
      endPtr(p);
      if (p.hover) { p.t0 = -1e9; p.x0 = e.clientX; p.y0 = e.clientY; } else S.ptr = null;   /* let go: it settles back */
      S.lastInput = now();
      if (tap) {
        var r = stage.getBoundingClientRect();
        flip(null, (e.clientX - r.left) / r.width >= 0.5 ? 1 : -1);
      }
      kick();
    }
    /* once a swipe tilts the card (or the page gave it every touch), the page stays put */
    function onTouchMove(e) { if (S.ptr && (S.ptr.grab || S.ptr.swipe) && e.cancelable) e.preventDefault(); }
    /* a long press on the card opens no menu (a mouse's right click still does) */
    function onMenu(e) { if (now() - (S.touchAt || -1e9) < 2500) e.preventDefault(); }
    function onDragStart(e) { e.preventDefault(); }
    function onCancel(e) { if (S.ptr && S.ptr.id === e.pointerId) { endPtr(S.ptr); S.ptr = null; S.lastInput = now(); kick(); } }
    function onLeave(e) { if (e.pointerType === 'mouse' && S.ptr && S.ptr.type === 'mouse' && !S.ptr.drag) { endPtr(S.ptr); S.ptr = null; S.lastInput = now(); kick(); } }

    function onKey(e) {
      if (e.target !== card) return;
      var k = e.key;
      if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); flip(null, 1); return; }
      if (S.rm) return;
      var step = { ArrowLeft: [0, 6], ArrowRight: [0, -6], ArrowUp: [-6, 0], ArrowDown: [6, 0] }[k];
      if (!step) return;
      e.preventDefault();
      var base = S.key || { rx: S.tx, ry: S.ty };
      S.key = { rx: clamp(base.rx + step[0], -MAX, MAX), ry: clamp(base.ry + step[1], -MAX, MAX), until: now() + 1600 };
      S.lastInput = now(); kick();
    }

    /* ---- input: gyroscope ---- */
    function gyroCapable() { return !small && 'DeviceOrientationEvent' in win && COARSE.matches && !S.rm; }
    function onOrient(e) {
      if (e.beta == null || e.gamma == null) return;
      S.gyroSeen = true;
      var ang = (win.screen && screen.orientation && screen.orientation.angle) || win.orientation || 0, x, y;
      if (ang === 90) { x = e.beta; y = -e.gamma; }
      else if (ang === -90 || ang === 270) { x = -e.beta; y = e.gamma; }
      else if (ang === 180) { x = -e.gamma; y = -e.beta; }
      else { x = e.gamma; y = e.beta; }
      if (!S.g0) S.g0 = { x: x, y: y };
      S.g0.x += (x - S.g0.x) * 0.006; S.g0.y += (y - S.g0.y) * 0.006;     /* drifts back to however you hold it */
      S.gt = { rx: clamp(-(y - S.g0.y) * 0.75, -MAX, MAX), ry: clamp((x - S.g0.x) * 0.75, -MAX, MAX) };
      S.lastGyro = now(); S.lastInput = now();
      kick();
    }
    function startGyro() {
      S.gyro = true; S.gyroSeen = false; S.g0 = null;
      win.addEventListener('deviceorientation', onOrient);
      btnGyro.setAttribute('aria-pressed', 'true');
      tell('Tilt your phone. The foil follows.');
      later(function () {
        if (S.gyro && !S.gyroSeen) { stopGyro(); btnGyro.hidden = true; tell('No motion sensor here. Drag across the card instead.'); }
      }, 1600);
    }
    function stopGyro() {
      S.gyro = false; win.removeEventListener('deviceorientation', onOrient);
      if (btnGyro) btnGyro.setAttribute('aria-pressed', 'false');
    }
    function onGyroBtn() {
      if (S.gyro) { stopGyro(); tell(''); return; }
      var DOE = win.DeviceOrientationEvent;
      if (DOE && typeof DOE.requestPermission === 'function') {
        DOE.requestPermission().then(function (r) {
          if (r === 'granted') startGyro(); else tell('Motion access is off. Drag across the card instead.');
        }).catch(function () { tell('Motion access is off. Drag across the card instead.'); });
      } else startGyro();
    }

    /* ---- visibility, motion preference ---- */
    function onSeen(en) {
      en.forEach(function (x) {
        if (x.isIntersecting && !S.visible) S.idleUntil = now() + IDLE_MS;
        S.visible = x.isIntersecting;
        if (x.isIntersecting && x.intersectionRatio >= 0.35 && !S.entered) {
          S.entered = true;
          if (opt.entrance !== false && !small) issue();
        }
      });
      if (S.visible) kick();
    }
    /* Seen means seen below the site's sticky header: the page's --bar (52px on phones, 64px from 900px up) comes
       off the top of the viewport, so a sliver under the header does not count. Without that variable (a lab page,
       say) nothing comes off. Read once; read again only after a resize, and rebuild only if it changed. */
    function barPx() { var v = parseFloat(win.getComputedStyle(doc.documentElement).getPropertyValue('--bar')); return v > 0 ? Math.round(v) : 0; }
    var io = null, ioTop = -1, ioT = 0;
    function watchSeen() {
      if (!win.IntersectionObserver || destroyed) return;
      var top = barPx(); if (io && top === ioTop) return;
      ioTop = top;
      if (io) io.disconnect();
      io = new IntersectionObserver(onSeen, { threshold: [0, 0.35], rootMargin: (-top) + 'px 0px 0px 0px' });
      io.observe(stage);   /* the card, not the whole root: the controls below it can show while the card is covered */
    }
    function onResizeSeen() { clearTimeout(ioT); ioT = setTimeout(watchSeen, 200); }
    function onVis() { if (!doc.hidden) kick(); }
    function onRM() {
      S.rm = RM.matches;
      root.classList.toggle('coa--rm', S.rm);
      if (S.rm) { S.fa = S.tf = S.back ? 180 : 0; S.rx = S.ry = S.vx = S.vy = S.vf = S.z = S.vz = 0; stopGyro(); }
      else { S.fa = S.tf = S.back ? 180 : 0; }
      if (btnGyro) btnGyro.hidden = !gyroCapable();
      paint(true); kick();
    }

    /* ---- wire up ---- */
    root.classList.toggle('coa--rm', S.rm);
    if (!small) {
      stage.addEventListener('pointerdown', onDown);
      stage.addEventListener('pointermove', onMove);
      stage.addEventListener('pointerup', onUp);
      stage.addEventListener('pointercancel', onCancel);
      stage.addEventListener('pointerleave', onLeave);
      stage.addEventListener('touchmove', onTouchMove, { passive: false });
      stage.addEventListener('dragstart', onDragStart);
      stage.addEventListener('contextmenu', onMenu);
      card.addEventListener('keydown', onKey);
      if (btnFlip) btnFlip.addEventListener('click', function () { flip(null, 1); });
      if (btnGyro) { btnGyro.hidden = !gyroCapable(); btnGyro.addEventListener('click', onGyroBtn); }
      if (win.IntersectionObserver) { watchSeen(); win.addEventListener('resize', onResizeSeen); } else { S.entered = true; S.idleUntil = now() + IDLE_MS; }
      doc.addEventListener('visibilitychange', onVis);
      if (RM.addEventListener) RM.addEventListener('change', onRM); else if (RM.addListener) RM.addListener(onRM);
    }
    if (!ro) measure();
    render(data);
    if (!small) kick();

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      if (raf) cancelAnimationFrame(raf);
      timers.forEach(clearTimeout);
      stopGyro();
      if (ro) ro.disconnect(); else win.removeEventListener('resize', measure);
      if (io) io.disconnect();
      clearTimeout(ioT); win.removeEventListener('resize', onResizeSeen);
      doc.removeEventListener('visibilitychange', onVis);
      if (RM.removeEventListener) RM.removeEventListener('change', onRM); else if (RM.removeListener) RM.removeListener(onRM);
      if (root.parentNode) root.parentNode.removeChild(root);
    }

    this.api = {
      el: root,
      update: update,
      flip: function (toBack) { return flip(toBack, 1); },
      tilt: function (rx, ry, o) {
        o = o || {};
        S.hold = { rx: clamp(+rx || 0, -MAX * 1.5, MAX * 1.5), ry: clamp(+ry || 0, -MAX * 1.5, MAX * 1.5), glare: o.glare == null ? 0.6 : +o.glare };
        if (o.instant) { S.rx = S.tx = S.hold.rx; S.ry = S.ty = S.hold.ry; S.vx = S.vy = 0; S.ga = S.gaT = S.hold.glare; }
        if (!o.hold) later(function () { S.hold = null; S.lastInput = now(); kick(); }, o.ms || 1400);
        S.lastInput = now(); paint(true); kick();
      },
      release: function () { S.hold = null; S.lastInput = now(); kick(); },
      destroy: destroy,
      get side() { return S.back ? 'back' : 'front'; },
      get data() { return d; }
    };
  }

  win.FlipsideCOA = {
    version: '1.0.0',
    mount: function (el, data, opt) {
      if (typeof el === 'string') el = doc.querySelector(el);
      if (!el) throw new Error('FlipsideCOA.mount: no element');
      var o = { size: 'md', controls: true, entrance: true };   /* hover and sway stay off unless a page asks */
      for (var k in (opt || {})) o[k] = opt[k];
      return new COA(el, data || {}, o).api;
    }
  };
})(window, document);
